import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any };
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: Date; output: Date };
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: number; output: number };
  /** The EmailAddress scalar type constitutes a valid email address, represented as a UTF-8 character sequence. The scalar follows the specification defined by the HTML Spec https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any };
  /** A measurement of energy in watt-hours (Wh). */
  EnergyMeasurement: { input: any; output: any };
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any };
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  LocalTime: { input: any; output: any };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any };
  /** A measurement of power in watts (W). */
  PowerMeasurement: { input: any; output: any };
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: { input: any; output: any };
  URL: { input: any; output: any };
  UUID: { input: string; output: string };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type AcceptCampaignOfferInput = {
  bankAccount?: InputMaybe<ChangeBankAccountInput>;
  code: Scalars['String']['input'];
  contractId: Scalars['Int']['input'];
  levyPrivilegeApplicationOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  levyPrivilegeApplicationOptInText?: InputMaybe<Scalars['String']['input']>;
  marketingText?: InputMaybe<Scalars['String']['input']>;
  optIn: Scalars['Boolean']['input'];
};

export enum ActivateHemGatewayErrorType {
  Duplicate = 'DUPLICATE',
  InvalidHemGateway = 'INVALID_HEM_GATEWAY',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  UnhandledError = 'UNHANDLED_ERROR',
}

export type ActivateHemGatewayInput = {
  hemGatewayId: Scalars['String']['input'];
};

export enum AddMeterReadingPayloadError {
  Contractnotfound = 'CONTRACTNOTFOUND',
  Fielderrors = 'FIELDERRORS',
  Futurereadingwithsmallervalue = 'FUTUREREADINGWITHSMALLERVALUE',
  Incorrectvalue = 'INCORRECTVALUE',
  Invaliddate = 'INVALIDDATE',
  Invalidprofilesum = 'INVALIDPROFILESUM',
  Noreadings = 'NOREADINGS',
  Obiscodemissing = 'OBISCODEMISSING',
  Obiscodesnotvalid = 'OBISCODESNOTVALID',
  Obiscodeunknown = 'OBISCODEUNKNOWN',
  Previousreadingwithhighervalue = 'PREVIOUSREADINGWITHHIGHERVALUE',
  Readingdatealreadyexists = 'READINGDATEALREADYEXISTS',
  Readingdateinbilledperiod = 'READINGDATEINBILLEDPERIOD',
  Readingdateinfuture = 'READINGDATEINFUTURE',
  Readingdateoutsidecontract = 'READINGDATEOUTSIDECONTRACT',
  Readingusagesumisnotplausible = 'READINGUSAGESUMISNOTPLAUSIBLE',
  Requestisnotallowed = 'REQUESTISNOTALLOWED',
  Toomanydigits = 'TOOMANYDIGITS',
  Undefined = 'UNDEFINED',
}

export type AddReadingInput = {
  /** Contract id for this reading */
  contractId: Scalars['Int']['input'];
  /** Date on which this reading is been read at in International format (YYYY-MM-DD) */
  date: Scalars['DateTime']['input'];
  /** A flag to notify that this reading should allow implausible values */
  forceImplausibleReading?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag to notify that this reading forcefully triggers an Invoice */
  forceInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** The reason for implausible readings */
  implausibleReadingReason?: InputMaybe<Scalars['String']['input']>;
  /** Values of the reading */
  readings?: InputMaybe<Array<InputMaybe<RegisterReadingInput>>>;
};

export enum AddReadingPayloadError {
  /** Contract Id not found on authorized customer */
  ContractNotFound = 'CONTRACT_NOT_FOUND',
  /** Fehlerhafte Zählerstände. Fehlerdetails in FieldErrors. */
  Fielderrors = 'FIELDERRORS',
  /** Es existiert bereits ein niedrigerer Zählerstand in der Zukunft */
  FutureReadingWithSmallerValue = 'FUTURE_READING_WITH_SMALLER_VALUE',
  /** Die Eingabe ist nicht korrekt */
  Incorrectvalue = 'INCORRECTVALUE',
  /** Ablesedatum liegt entweder außerhalb der Vertragsbelieferung oder Datum ist ungültig. Datum muss im Format YYYY-MM-DD sein. */
  Invaliddate = 'INVALIDDATE',
  /** Unplausible Daten */
  InvalidProfileSum = 'INVALID_PROFILE_SUM',
  /** No readings were committed or OBIS codes were empty */
  NoReadings = 'NO_READINGS',
  /** Obis-Codes der Zählwerke sind nicht korrekt */
  ObiscodesNotValid = 'OBISCODES_NOT_VALID',
  /** OBIS Code was not submitted but is present on the contract's counter */
  ObisCodeMissing = 'OBIS_CODE_MISSING',
  /** OBIS Code was submitted but is unknown for this contract */
  ObisCodeUnknown = 'OBIS_CODE_UNKNOWN',
  /** Es existiert bereits ein höherer in der Vergangenheit */
  PreviousReadingWithHigherValue = 'PREVIOUS_READING_WITH_HIGHER_VALUE',
  /** A reading for this reading date already exists */
  ReadingDateAlreadyExists = 'READING_DATE_ALREADY_EXISTS',
  /** The reading date is already covered by an invoice */
  ReadingDateInBilledPeriod = 'READING_DATE_IN_BILLED_PERIOD',
  /** No readings for the future may be committed */
  ReadingDateInFuture = 'READING_DATE_IN_FUTURE',
  /** The reading date is outside of StartDate-EndDate */
  ReadingDateOutsideContract = 'READING_DATE_OUTSIDE_CONTRACT',
  /** Der Verbrauch ist nicht plausibel */
  ReadingUsageSumIsNotPlausible = 'READING_USAGE_SUM_IS_NOT_PLAUSIBLE',
  /** Vorgang ist nicht erlaubt */
  RequestIsNotAllowed = 'REQUEST_IS_NOT_ALLOWED',
  /** This register has less significant digits than were submitted */
  TooManyDigits = 'TOO_MANY_DIGITS',
  /** Unbekannter Fehler */
  Undefined = 'UNDEFINED',
  /** Count of OBIS Codes not matching PowerCloud */
  WrongObisCodeCount = 'WRONG_OBIS_CODE_COUNT',
}

export type AddressFilterInput = {
  and?: InputMaybe<Array<AddressFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  houseNumber?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressFilterInput>>;
  street?: InputMaybe<StringOperationFilterInput>;
  zip?: InputMaybe<StringOperationFilterInput>;
};

export type AddressSortInput = {
  city?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  houseNumber?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  street?: InputMaybe<SortEnumType>;
  zip?: InputMaybe<SortEnumType>;
};

export enum AppContractContentCard {
  BillingAddress = 'BILLING_ADDRESS',
  ChargeHistory = 'CHARGE_HISTORY',
  ContractDetails = 'CONTRACT_DETAILS',
  CostBalance = 'COST_BALANCE',
  DeliveryAddress = 'DELIVERY_ADDRESS',
  Deposit = 'DEPOSIT',
  DynamicFallback = 'DYNAMIC_FALLBACK',
  MeterReading = 'METER_READING',
  PaymentInfo = 'PAYMENT_INFO',
  ProductHeader = 'PRODUCT_HEADER',
  Status = 'STATUS',
  TaskSummary = 'TASK_SUMMARY',
  Teaser = 'TEASER',
  WorkingPrice = 'WORKING_PRICE',
}

export enum AppProductCategory {
  Fahrstrom = 'FAHRSTROM',
  Gas = 'GAS',
  Heatpump = 'HEATPUMP',
  Power = 'POWER',
  Storageheater = 'STORAGEHEATER',
  Stromwallet = 'STROMWALLET',
  Unknown = 'UNKNOWN',
}

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION',
}

export type B2CCommodityLeadInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  estimatedUsageElectricity?: InputMaybe<Scalars['Int']['input']>;
  estimatedUsageGas?: InputMaybe<Scalars['Int']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  fullname: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isExistingCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  marketingCampaignIdentifier: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  optin: Scalars['Boolean']['input'];
  optinText?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum B2bRsBillingEndMonth {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER',
}

export enum B2bRsBillingInterval {
  Annually = 'ANNUALLY',
  BiMonthly = 'BI_MONTHLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  TetraMonthly = 'TETRA_MONTHLY',
}

export enum B2bRsBillingType {
  BillingInvoice = 'BILLING_INVOICE',
  BillingPlan = 'BILLING_PLAN',
  LiveBilling = 'LIVE_BILLING',
}

export type B2bRsBusinessTariffGridInput = {
  city: Scalars['String']['input'];
  cityDistrict?: InputMaybe<Scalars['String']['input']>;
  commodity: B2bRsCommodity;
  houseNumber: Scalars['Int']['input'];
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  tariffMetering: B2bRsTariffMetering;
  yearlyConsumptionForecast?: InputMaybe<Scalars['Long']['input']>;
};

export enum B2bRsCalculateDeliveryLocationPriceErrorType {
  InternalError = 'INTERNAL_ERROR',
  InvalidRequestForElectricityCommodity = 'INVALID_REQUEST_FOR_ELECTRICITY_COMMODITY',
}

export type B2bRsCalculateDeliverySitePricesInput = {
  /** In Euro */
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  bindingPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** For concession-fee */
  city: Scalars['String']['input'];
  /** In cents kw/h */
  comissionSalesPartner?: InputMaybe<Scalars['Decimal']['input']>;
  commodity: B2bRsCommodity;
  consumptionHt: Scalars['Decimal']['input'];
  consumptionNt?: InputMaybe<Scalars['Decimal']['input']>;
  /** In cents kw/h */
  contributionMargin?: InputMaybe<Scalars['Decimal']['input']>;
  deliveryEnd: Scalars['DateTime']['input'];
  deliveryStart: Scalars['DateTime']['input'];
  /** Only For Gas */
  gasCounterType?: InputMaybe<B2bRsGasCounterType>;
  /** Only For Gas */
  gasPressureLevel?: InputMaybe<B2bRsGasPressureLevel>;
  /** Only For Gas */
  gasProfile?: InputMaybe<B2bRsGasProfile>;
  /** Get it from the query 'GetBusinessTariffGrids' */
  gridId: Scalars['Long']['input'];
  /** In cents kw/h */
  onTopSalesRepresentative?: InputMaybe<Scalars['Decimal']['input']>;
  /** For concession-fee */
  postalCode: Scalars['String']['input'];
};

export enum B2bRsCalculateWorkPriceErrorType {
  InternalError = 'INTERNAL_ERROR',
}

export type B2bRsCalculateWorkPricesInput = {
  /** In euros */
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** In cents kw/h */
  commissionSalesPartner?: InputMaybe<Scalars['Decimal']['input']>;
  commodity: B2bRsCommodity;
  /** Annual consumption plan in cents kw/h */
  consumptionHt: Scalars['Decimal']['input'];
  /** Annual consumption plan in cents kw/h */
  consumptionNt?: InputMaybe<Scalars['Decimal']['input']>;
  /** In cents kw/h */
  contributionMargin?: InputMaybe<Scalars['Decimal']['input']>;
  deliveryEnd?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** In cents kw/h */
  onTopSalesRepresentative?: InputMaybe<Scalars['Decimal']['input']>;
};

export type B2bRsCheckAddressInput = {
  city: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['Int']['input']>;
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  postalBox?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export enum B2bRsCommodity {
  Electricity = 'ELECTRICITY',
  Gas = 'GAS',
}

export enum B2bRsConcessionType {
  Gas = 'GAS',
  Inkl = 'INKL',
  Svk = 'SVK',
  SvkNt = 'SVK_NT',
  Tk1 = 'TK1',
  Tk2 = 'TK2',
  Tk3 = 'TK3',
  Tk4 = 'TK4',
  TkNt = 'TK_NT',
}

export type B2bRsCreateAddressInput = {
  addressAddition?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type B2bRsCreateCustomerInput = {
  address: B2bRsCreateAddressInput;
  companyName: Scalars['String']['input'];
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type B2bRsCreateMeterAddressInput = {
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type B2bRsCreateMeterElectricityPropertiesInput = {
  /** In kWh */
  consumptionHt: Scalars['Int']['input'];
  /** In kWh */
  consumptionNt?: InputMaybe<Scalars['Int']['input']>;
  meterType: B2bRsElectricityMeterType;
};

export enum B2bRsCreateMeterErrorType {
  DeliveryProcessInformationIncoherent = 'DELIVERY_PROCESS_INFORMATION_INCOHERENT',
  InsufficientConsumptionHt = 'INSUFFICIENT_CONSUMPTION_HT',
  MissingAddressInformation = 'MISSING_ADDRESS_INFORMATION',
  NoCommoditySpecified = 'NO_COMMODITY_SPECIFIED',
  OpportunityNotFound = 'OPPORTUNITY_NOT_FOUND',
  PreviousSupplierInformationMissing = 'PREVIOUS_SUPPLIER_INFORMATION_MISSING',
  StartDateTooFarInTheFuture = 'START_DATE_TOO_FAR_IN_THE_FUTURE',
}

export type B2bRsCreateMeterInput = {
  address: B2bRsCreateMeterAddressInput;
  /** The CustomerId of the customer that's using this meter */
  connectionUserId: Scalars['UUID']['input'];
  deliveryProcess: B2bRsDeliveryProcess;
  deliveryStart: Scalars['Date']['input'];
  electricityProperties?: InputMaybe<B2bRsCreateMeterElectricityPropertiesInput>;
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  opportunityId: Scalars['UUID']['input'];
  previousSupplier?: InputMaybe<B2bRsCreateMeterPreviousSupplierInput>;
  previousSupplierAlreadyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type B2bRsCreateMeterPreviousSupplierInput = {
  /** @deprecated Use PreviousSupplierAlreadyTerminated on the parent instead */
  alreadyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  previousSupplierId: Scalars['String']['input'];
};

export enum B2bRsCreateOfferErrorType {
  EmptyMeterListProvided = 'EMPTY_METER_LIST_PROVIDED',
  MeterStillPendingToSync = 'METER_STILL_PENDING_TO_SYNC',
  OfferIsAlreadySignedInOfferPackage = 'OFFER_IS_ALREADY_SIGNED_IN_OFFER_PACKAGE',
  OfferPackageNotFound = 'OFFER_PACKAGE_NOT_FOUND',
  OpportunityNotFound = 'OPPORTUNITY_NOT_FOUND',
  OpportunityWithoutMeters = 'OPPORTUNITY_WITHOUT_METERS',
}

export type B2bRsCreateOfferInput = {
  billingEndMonth: B2bRsBillingEndMonth;
  billingInterval: B2bRsBillingInterval;
  billingType: B2bRsBillingType;
  commodity: B2bRsCommodity;
  electricityQuality: B2bRsElectricityQuality;
  meterIds: Array<Scalars['UUID']['input']>;
  offerPackageId?: InputMaybe<Scalars['UUID']['input']>;
  opportunityId: Scalars['UUID']['input'];
  product: B2bRsProduct;
  relativeBindingPeriod?: InputMaybe<Scalars['Int']['input']>;
  relativeContributionMargin?: InputMaybe<Scalars['Decimal']['input']>;
  standingCharge?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum B2bRsCreateOpportunityErrorType {
  MissingAddressInformation = 'MISSING_ADDRESS_INFORMATION',
  MissingCompanyName = 'MISSING_COMPANY_NAME',
  MissingContactInformation = 'MISSING_CONTACT_INFORMATION',
}

export type B2bRsCreateOpportunityInput = {
  customer: B2bRsCreateCustomerInput;
  meterCountElectricity?: InputMaybe<Scalars['Int']['input']>;
  totalJpvElectricity?: InputMaybe<Scalars['Int']['input']>;
};

export enum B2bRsDeliveryProcess {
  NewMoveIn = 'NEW_MOVE_IN',
  SupplierChange = 'SUPPLIER_CHANGE',
}

export enum B2bRsElectricityMeterType {
  DoubleTariff = 'DOUBLE_TARIFF',
  SingleTariff = 'SINGLE_TARIFF',
}

export enum B2bRsElectricityQuality {
  GermanMix = 'GERMAN_MIX',
  GermanSolar = 'GERMAN_SOLAR',
  GermanWater = 'GERMAN_WATER',
  GermanWind = 'GERMAN_WIND',
  TuvNorth = 'TUV_NORTH',
}

export enum B2bRsGasCounterType {
  Diaphragm = 'DIAPHRAGM',
  RotaryDisplacement = 'ROTARY_DISPLACEMENT',
  Turbine = 'TURBINE',
}

export enum B2bRsGasPressureLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum B2bRsGasProfile {
  G2Point5 = 'G2_POINT5',
  G4 = 'G4',
  G6 = 'G6',
  G10 = 'G10',
  G16 = 'G16',
  G25 = 'G25',
  G40 = 'G40',
  G65 = 'G65',
  G100 = 'G100',
  G160 = 'G160',
  G250 = 'G250',
  G400 = 'G400',
  G650 = 'G650',
  G1000 = 'G1000',
  G1600 = 'G1600',
  G2500 = 'G2500',
  G4000 = 'G4000',
  G6500 = 'G6500',
}

export enum B2bRsGetBankInformationErrorType {
  InvalidIban = 'INVALID_IBAN',
  NoBankInformation = 'NO_BANK_INFORMATION',
}

export enum B2bRsGetBusinessTariffGridsErrorType {
  InvalidAddress = 'INVALID_ADDRESS',
}

export enum B2bRsIssueOfferErrorType {
  BindingPeriodAlreadyExpired = 'BINDING_PERIOD_ALREADY_EXPIRED',
  OfferMustBeCalculated = 'OFFER_MUST_BE_CALCULATED',
  OfferNotFound = 'OFFER_NOT_FOUND',
  OfferVariantNotFound = 'OFFER_VARIANT_NOT_FOUND',
  OpportunityNotFound = 'OPPORTUNITY_NOT_FOUND',
}

export type B2bRsIssueOfferInput = {
  offerId: Scalars['UUID']['input'];
  offerVariantId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
};

export enum B2bRsOfferStatus {
  AlternativeChosen = 'ALTERNATIVE_CHOSEN',
  Calculated = 'CALCULATED',
  Expired = 'EXPIRED',
  InCalculation = 'IN_CALCULATION',
  InIssuing = 'IN_ISSUING',
  InWithdrawal = 'IN_WITHDRAWAL',
  Issued = 'ISSUED',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Signed = 'SIGNED',
  Withdrawn = 'WITHDRAWN',
}

export enum B2bRsOfferVariantStatus {
  Discarded = 'DISCARDED',
  Issued = 'ISSUED',
  Lost = 'LOST',
  Open = 'OPEN',
  Selected = 'SELECTED',
  Withdrawn = 'WITHDRAWN',
  Won = 'WON',
}

export enum B2bRsOpportunityStatus {
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
}

export enum B2bRsProcessStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING',
}

export enum B2bRsProcessType {
  UpsertAndCalculateOffer = 'UPSERT_AND_CALCULATE_OFFER',
  UpsertMeter = 'UPSERT_METER',
}

export enum B2bRsProduct {
  ElectricityBackToBack = 'ELECTRICITY_BACK_TO_BACK',
  ElectricityBackToBackDoubleTariff = 'ELECTRICITY_BACK_TO_BACK_DOUBLE_TARIFF',
  ElectricitySpot = 'ELECTRICITY_SPOT',
}

export type B2bRsSelectOfferVariantInput = {
  offerId: Scalars['UUID']['input'];
  offerVariantId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
};

export type B2bRsStartSingleDeliverySiteCalculationInput = {
  /** In Euro */
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** For concession-fee */
  city: Scalars['String']['input'];
  /** In cents kWh */
  commissionSalesPartner?: InputMaybe<Scalars['Decimal']['input']>;
  commodity: B2bRsCommodity;
  companyName: Scalars['String']['input'];
  /** In kWh */
  consumptionHt: Scalars['Int']['input'];
  /** In kWh */
  consumptionNt?: InputMaybe<Scalars['Int']['input']>;
  /** In cents kWh */
  contributionMargin?: InputMaybe<Scalars['Decimal']['input']>;
  deliveryEnd: Scalars['DateTime']['input'];
  deliveryStart: Scalars['DateTime']['input'];
  /** For concession-fee */
  houseNumber: Scalars['String']['input'];
  /** For concession-fee */
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  /** In cents kWh */
  onTopSalesRepresentative?: InputMaybe<Scalars['Decimal']['input']>;
  /** For concession-fee */
  postalCode: Scalars['String']['input'];
  /** In days */
  relativeBindingPeriod: Scalars['Int']['input'];
  /** For concession-fee */
  street: Scalars['String']['input'];
};

export enum B2bRsTariffMetering {
  SingleTariff = 'SINGLE_TARIFF',
  TwoTariff = 'TWO_TARIFF',
}

export type B2bRsUpdateMeterAddressInput = {
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type B2bRsUpdateMeterElectricityPropertiesInput = {
  /** In kWh */
  consumptionHt: Scalars['Int']['input'];
  /** In kWh */
  consumptionNt?: InputMaybe<Scalars['Int']['input']>;
  meterType: B2bRsElectricityMeterType;
};

export type B2bRsUpdateMeterInput = {
  address: B2bRsUpdateMeterAddressInput;
  deliveryProcess: B2bRsDeliveryProcess;
  electricityProperties: B2bRsUpdateMeterElectricityPropertiesInput;
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  meterId: Scalars['UUID']['input'];
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  opportunityId: Scalars['UUID']['input'];
  previousSupplier?: InputMaybe<B2bRsUpdateMeterPreviousSupplierInput>;
};

export type B2bRsUpdateMeterPreviousSupplierInput = {
  alreadyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  previousSupplierId: Scalars['String']['input'];
};

export enum B2bRsUpdateOfferErrorType {
  InvalidOfferStatusTransition = 'INVALID_OFFER_STATUS_TRANSITION',
  OfferAlreadyInCalculation = 'OFFER_ALREADY_IN_CALCULATION',
  OfferNotFound = 'OFFER_NOT_FOUND',
  OpportunityNotFound = 'OPPORTUNITY_NOT_FOUND',
}

export type B2bRsUpdateOfferInput = {
  electricityQuality?: InputMaybe<B2bRsElectricityQuality>;
  offerId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
  relativeBindingPeriod: Scalars['Int']['input'];
  relativeContributionMargin?: InputMaybe<Scalars['Decimal']['input']>;
  standingCharge?: InputMaybe<Scalars['Decimal']['input']>;
};

export type B2bRsWithdrawOfferInput = {
  offerId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export enum B2bRsWithdrawnOfferErrorType {
  MissingAgreementIdOnOffer = 'MISSING_AGREEMENT_ID_ON_OFFER',
  OfferIsNotIssued = 'OFFER_IS_NOT_ISSUED',
  OfferNotFound = 'OFFER_NOT_FOUND',
  OpportunityNotFound = 'OPPORTUNITY_NOT_FOUND',
}

export enum B2bSpBillingEndMonth {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER',
}

export enum B2bSpBillingInterval {
  Annually = 'ANNUALLY',
  BiMonthly = 'BI_MONTHLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  TetraMonthly = 'TETRA_MONTHLY',
}

export enum B2bSpBillingType {
  BillingInvoice = 'BILLING_INVOICE',
  BillingPlan = 'BILLING_PLAN',
  LiveBilling = 'LIVE_BILLING',
}

export enum B2bSpCommodity {
  Electricity = 'ELECTRICITY',
  Gas = 'GAS',
}

export type B2bSpCreateElectricityMeterContractInput = {
  accountingProcedure: B2bSpElectricityAccountingProcedure;
  address: B2bSpCreateMeterAddressContractInput;
  /** The CustomerId of the customer that's using this meter */
  connectionUserId: Scalars['UUID']['input'];
  consumption: Scalars['Int']['input'];
  deliveryProcess: B2bSpDeliveryProcess;
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  meterType?: B2bSpElectricityMeterType;
  /** @deprecated Please migrate to use the ElectricityMeterType */
  meteringProcedure?: InputMaybe<B2bSpMeteringProcedure>;
  opportunityId: Scalars['UUID']['input'];
  peakConsumption?: InputMaybe<Scalars['Decimal']['input']>;
  previousSupplier?: InputMaybe<B2bSpCreateMarketPartnerContractInput>;
  previousSupplierAlreadyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['Date']['input'];
};

export type B2bSpCreateGasMeterContractInput = {
  address: B2bSpCreateMeterAddressContractInput;
  /** The CustomerId of the customer that's using this meter */
  connectionUserId: Scalars['UUID']['input'];
  consumption: Scalars['Int']['input'];
  deliveryProcess: B2bSpDeliveryProcess;
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  meterSize: B2bSpGasMeterSize;
  meterType: B2bSpGasMeterType;
  opportunityId: Scalars['UUID']['input'];
  pressureLevel: B2bSpGasPressureLevel;
  previousSupplier?: InputMaybe<B2bSpCreateMarketPartnerContractInput>;
  previousSupplierAlreadyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['Date']['input'];
};

export type B2bSpCreateMarketPartnerContractInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type B2bSpCreateMeterAddressContractInput = {
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type B2bSpCreateOfferContractInput = {
  billingEndMonth: B2bSpBillingEndMonth;
  billingInterval: B2bSpBillingInterval;
  billingType: B2bSpBillingType;
  commodity: B2bSpCommodity;
  electricityQuality?: InputMaybe<B2bSpElectricityQuality>;
  meterIds: Array<Scalars['UUID']['input']>;
  opportunityId: Scalars['UUID']['input'];
  product: B2bSpProduct;
  relativeBindingPeriod: Scalars['Int']['input'];
  relativeContributionMargin: Scalars['Decimal']['input'];
  standingCharge: Scalars['Decimal']['input'];
};

export type B2bSpCreateOpportunityContractInput = {
  customer: B2bSpCustomerContractInput;
  meterCountElectricity?: InputMaybe<Scalars['Int']['input']>;
  meterCountGas?: InputMaybe<Scalars['Int']['input']>;
  totalJpvElectricity?: InputMaybe<Scalars['Int']['input']>;
  totalJpvGas?: InputMaybe<Scalars['Int']['input']>;
};

export type B2bSpCustomerAddressContractInput = {
  addressAddition?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type B2bSpCustomerContractInput = {
  address: B2bSpCustomerAddressContractInput;
  companyName: Scalars['String']['input'];
  customerNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum B2bSpDeliveryProcess {
  NewMoveIn = 'NEW_MOVE_IN',
  SupplierChange = 'SUPPLIER_CHANGE',
}

export enum B2bSpElectricityAccountingProcedure {
  Rlm = 'RLM',
  Slp = 'SLP',
}

export enum B2bSpElectricityMeterType {
  DoubleTariff = 'DOUBLE_TARIFF',
  LoadProfile = 'LOAD_PROFILE',
  SingleTariff = 'SINGLE_TARIFF',
}

export enum B2bSpElectricityQuality {
  GermanMix = 'GERMAN_MIX',
  GermanSolar = 'GERMAN_SOLAR',
  GermanWater = 'GERMAN_WATER',
  GermanWind = 'GERMAN_WIND',
  TuvNorth = 'TUV_NORTH',
}

export enum B2bSpEventEntityType {
  Customer = 'CUSTOMER',
  Meter = 'METER',
  Offer = 'OFFER',
  Opportunity = 'OPPORTUNITY',
}

export enum B2bSpGasMeterSize {
  G2_5 = 'G2_5',
  G4 = 'G4',
  G6 = 'G6',
  G10 = 'G10',
  G16 = 'G16',
  G25 = 'G25',
  G40 = 'G40',
  G65 = 'G65',
  G100 = 'G100',
  G160 = 'G160',
  G250 = 'G250',
  G400 = 'G400',
  G650 = 'G650',
  G1000 = 'G1000',
  G1600 = 'G1600',
  G2500 = 'G2500',
  G4000 = 'G4000',
  G6500 = 'G6500',
}

export enum B2bSpGasMeterType {
  Bellows = 'BELLOWS',
  RotaryPistons = 'ROTARY_PISTONS',
  Turbins = 'TURBINS',
}

export enum B2bSpGasPressureLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type B2bSpGetDeliverySituationsOfSelectedOfferVariantContractInput = {
  offerId: Scalars['UUID']['input'];
};

export type B2bSpGetEndBindingPeriodListContractInput = {
  maxDurationInDays: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type B2bSpGetMetersContractInput = {
  commodity?: B2bSpCommodity;
  opportunityId: Scalars['UUID']['input'];
};

export type B2bSpGetOfferContractInput = {
  offerId: Scalars['UUID']['input'];
};

export type B2bSpGetOffersContractInput = {
  opportunityId: Scalars['UUID']['input'];
};

export type B2bSpGetOpportunityContractInput = {
  opportunityId: Scalars['UUID']['input'];
};

export type B2bSpGetPriceDetailsOfSelectedOfferVariantContractInput = {
  offerId: Scalars['UUID']['input'];
};

export type B2bSpGetProcessesContractInput = {
  ignoreCompleted: Scalars['Boolean']['input'];
  opportunityId: Scalars['UUID']['input'];
};

export type B2bSpIssueOfferContractInput = {
  offerId: Scalars['UUID']['input'];
  offerMessage?: InputMaybe<Scalars['String']['input']>;
  offerVariantId: Scalars['UUID']['input'];
};

export type B2bSpMarkOrderAsTransferredContractInput = {
  orderId: Scalars['UUID']['input'];
  orderLegacyErpNumber: Scalars['String']['input'];
};

export enum B2bSpMeteringProcedure {
  Rlm = 'RLM',
  Slp = 'SLP',
}

export enum B2bSpOfferStatus {
  AlternativeChosen = 'ALTERNATIVE_CHOSEN',
  Calculated = 'CALCULATED',
  Expired = 'EXPIRED',
  InCalculation = 'IN_CALCULATION',
  InClosing = 'IN_CLOSING',
  InIssuing = 'IN_ISSUING',
  Issued = 'ISSUED',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Signed = 'SIGNED',
  Withdrawn = 'WITHDRAWN',
}

export type B2bSpOfferStatusOperationFilterInput = {
  eq?: InputMaybe<B2bSpOfferStatus>;
  in?: InputMaybe<Array<B2bSpOfferStatus>>;
  neq?: InputMaybe<B2bSpOfferStatus>;
  nin?: InputMaybe<Array<B2bSpOfferStatus>>;
};

export enum B2bSpOfferVariantStatus {
  Discarded = 'DISCARDED',
  Issued = 'ISSUED',
  Lost = 'LOST',
  Open = 'OPEN',
  Selected = 'SELECTED',
  Won = 'WON',
}

export enum B2bSpOpportunityStatus {
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
}

export enum B2bSpOrderStatus {
  Pending = 'PENDING',
  Transferred = 'TRANSFERRED',
}

export enum B2bSpProcessStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING',
}

export enum B2bSpProcessType {
  IssueOffer = 'ISSUE_OFFER',
  OfferAgreementStateChanged = 'OFFER_AGREEMENT_STATE_CHANGED',
  UpsertAndCalculateOffer = 'UPSERT_AND_CALCULATE_OFFER',
  UpsertCustomer = 'UPSERT_CUSTOMER',
  UpsertMeter = 'UPSERT_METER',
  WithdrawOffer = 'WITHDRAW_OFFER',
}

export enum B2bSpProduct {
  ElectricityBackToBack = 'ELECTRICITY_BACK_TO_BACK',
  ElectricitySpot = 'ELECTRICITY_SPOT',
}

export type B2bSpRecentOfferContractFilterInput = {
  absoluteBindingPeriod?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<B2bSpRecentOfferContractFilterInput>>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  closedAt?: InputMaybe<DateTimeOperationFilterInput>;
  companyName?: InputMaybe<B2bSpStringOperationFilterInput>;
  contactEmail?: InputMaybe<B2bSpStringOperationFilterInput>;
  contactFullName?: InputMaybe<B2bSpStringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  issuedAt?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  offerNumber?: InputMaybe<B2bSpStringOperationFilterInput>;
  or?: InputMaybe<Array<B2bSpRecentOfferContractFilterInput>>;
  status?: InputMaybe<B2bSpOfferStatusOperationFilterInput>;
};

export type B2bSpRecentOfferContractSortInput = {
  absoluteBindingPeriod?: InputMaybe<SortEnumType>;
  calculatedAt?: InputMaybe<SortEnumType>;
  closedAt?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  issuedAt?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  offerNumber?: InputMaybe<SortEnumType>;
};

export type B2bSpSelectOfferVariantContractInput = {
  offerId: Scalars['UUID']['input'];
  offerVariantId: Scalars['UUID']['input'];
};

export type B2bSpStringOperationFilterInput = {
  and?: InputMaybe<Array<B2bSpStringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<B2bSpStringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum B2bSpTransferType {
  Gm = 'GM',
  Manual = 'MANUAL',
  Sdk = 'SDK',
}

export type B2bSpUpdateOfferContractInput = {
  electricityQuality?: InputMaybe<B2bSpElectricityQuality>;
  offerId: Scalars['UUID']['input'];
  opportunityId: Scalars['UUID']['input'];
  relativeBindingPeriod: Scalars['Int']['input'];
  relativeContributionMargin: Scalars['Decimal']['input'];
  standingCharge: Scalars['Decimal']['input'];
};

export type B2bSpWithdrawOfferContractInput = {
  offerId: Scalars['UUID']['input'];
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export type B2bcsConsentInput = {
  confirmed: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum B2bcsCreateLeadFormErrorType {
  InvalidAddress = 'INVALID_ADDRESS',
  InvalidCompany = 'INVALID_COMPANY',
  InvalidContact = 'INVALID_CONTACT',
  InvalidEnergyData = 'INVALID_ENERGY_DATA',
  InvalidGasData = 'INVALID_GAS_DATA',
}

export type B2bcsCreateLeadFormInput = {
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  customerMessage?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  energyAnualConsumptionPlan?: InputMaybe<Scalars['Int']['input']>;
  energyMeterCount?: InputMaybe<Scalars['Int']['input']>;
  firstname: Scalars['String']['input'];
  gasAnualConsumptionPlan?: InputMaybe<Scalars['Int']['input']>;
  gasMeterCount?: InputMaybe<Scalars['Int']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  telephoneNumber: Scalars['String']['input'];
  webCampaignId?: InputMaybe<Scalars['String']['input']>;
};

export type B2bcsInterestInput = {
  message: Scalars['String']['input'];
  products: Array<B2bcsProductInput>;
};

export type B2bcsKeyValuePairOfStringAndStringInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type B2bcsProductInput = {
  attributes: Array<B2bcsKeyValuePairOfStringAndStringInput>;
  code: Scalars['String']['input'];
  totalJpv?: InputMaybe<Scalars['Int']['input']>;
};

export enum B2bcsSubmitLeadFormErrorType {
  InvalidAddress = 'INVALID_ADDRESS',
  InvalidCompany = 'INVALID_COMPANY',
  InvalidContact = 'INVALID_CONTACT',
}

export type B2bcsSubmitLeadFormInput = {
  channelDetail?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  consents?: InputMaybe<Array<B2bcsConsentInput>>;
  emailAddress: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  interest?: InputMaybe<B2bcsInterestInput>;
  lastname: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  telephoneNumber: Scalars['String']['input'];
  webCampaignId?: InputMaybe<Scalars['String']['input']>;
};

/** To add a contact request you can choose between different payloads. The contract address request can be used for B2C and B2B customers that are not authenticated. The contract request payload can only be used for authenticated B2C customers. */
export type B2cAddContactRequestInput = {
  /** Use this input to add a contact request for a B2B or B2C customer. This input does not require authentification. */
  contractAddressRequestPayload?: InputMaybe<B2cContactRequestByContractAddressPayloadInput>;
  /** Use this input to add a contact request for an authenticated B2C customer. */
  contractRequestPayload?: InputMaybe<B2cContactRequestByContractPayloadInput>;
  /** Use this input to add a contact request for a lead (Interessenten). This input does not require authentification. */
  leadRequestPayload?: InputMaybe<B2cContactRequestForLeadsPayloadInput>;
};

export type B2cAddContractExtensionTariffChangeRequestInput = {
  /** Banking details to be used for direct debit payments. If this is empty, the contract will switch to bank transfers. */
  bankingDetails?: InputMaybe<B2cBankingDetailsInput>;
  /** The contract id associated with the tariff change request. */
  contractId: Scalars['Int']['input'];
  /** A flag to keep the current contracts banking details. */
  keepBankingDetails: Scalars['Boolean']['input'];
  /** Application for the levy privilege as per the §22 Law. */
  levyPrivilegeApplication: B2cLevyPrivilegeApplicationInput;
  /** A flag declaring the marketing opt in associated with the accepted offer was given. */
  marketingOptIn: Scalars['Boolean']['input'];
  /** The text for the accepted marketing opt in. This is required if the marketing opt in is given. */
  marketingText?: InputMaybe<Scalars['String']['input']>;
  /** The unique offer id of the accepted offer. */
  offerId: Scalars['String']['input'];
};

/** To request a grid fee reduction module change you need to either provide the contract id for an authenticated query or the contracts meter number for an anonymous query. */
export type B2cAddGridFeeReductionModuleChangeRequestInput = {
  /** Use this input to request a grid fee reduction model change using just the contracts meter number. This input does not require authentification. */
  contractMeterNumberRequestPayload?: InputMaybe<B2cContractMeterNumberRequestPayloadInput>;
  /** Use this input to request a grid fee reduction model change using just the contract id. This input requires authentification. */
  contractRequestPayload?: InputMaybe<B2cContractRequestPayloadInput>;
};

export type B2cAddLevyPrivilegeApplicationInput = {
  contractId: Scalars['Int']['input'];
  counterNumber: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  optIn: Scalars['Boolean']['input'];
  optInText: Scalars['String']['input'];
};

export type B2cAddReadingInput = {
  /** Add a reading for a contract of the currently logged in customer. */
  contractDetailsPayload?: InputMaybe<B2cContractDetailsPayloadInput>;
};

export type B2cAddRetentionTariffChangeRequestInput = {
  /** Banking details to be used for direct debit payments. If this is empty, the contract will switch to bank transfers. */
  bankingDetails?: InputMaybe<B2cBankingDetailsInput>;
  /** The contract id associated with the tariff change request. */
  contractId: Scalars['Int']['input'];
  /** A flag to keep the current contracts banking details. */
  keepBankingDetails: Scalars['Boolean']['input'];
  /** Application for the levy privilege as per the §22 Law. */
  levyPrivilegeApplication: B2cLevyPrivilegeApplicationInput;
  /** A flag declaring the marketing opt in associated with the accepted offer was given. */
  marketingOptIn: Scalars['Boolean']['input'];
  /** The text for the accepted marketing opt in. This is required if the marketing opt in is given. */
  marketingText?: InputMaybe<Scalars['String']['input']>;
  /** The unique offer id of the accepted offer. */
  offerId: Scalars['String']['input'];
};

/** To request a tariff change you need to provide the input corresponding with the offer type. */
export type B2cAddTariffChangeRequestInput = {
  contractExtensionRequestPayload?: InputMaybe<B2cAddContractExtensionTariffChangeRequestInput>;
  retentionRequestPayload?: InputMaybe<B2cAddRetentionTariffChangeRequestInput>;
  upSellRequestPayload?: InputMaybe<B2cAddUpSellTariffChangeRequestInput>;
  varioRequestPayload?: InputMaybe<B2cAddVarioTariffChangeRequestInput>;
  winBackRequestPayload?: InputMaybe<B2cAddWinBackTariffChangeRequestInput>;
};

/** To request a contract termination you need to either provide the contract id for an authenticated request or the contracts address for an anonymous request. */
export type B2cAddTerminationRequestInput = {
  /** Use this input to request a contract termination using the contracts address details. This input does not require authentification. */
  contractAddressRequestPayload?: InputMaybe<B2cTerminationRequestByAddressPayloadInput>;
  /** Use this input to request a contract termination using the contract id. This input requires authentification. */
  contractRequestPayload?: InputMaybe<B2cTerminationRequestByContractPayloadInput>;
};

export type B2cAddUpSellTariffChangeRequestInput = {
  /** Banking details to be used for direct debit payments. If this is empty, the contract will switch to bank transfers. */
  bankingDetails?: InputMaybe<B2cBankingDetailsInput>;
  /** The contract id associated with the tariff change request. */
  contractId: Scalars['Int']['input'];
  /** A flag to keep the current contracts banking details. */
  keepBankingDetails: Scalars['Boolean']['input'];
  /** Application for the levy privilege as per the §22 Law. */
  levyPrivilegeApplication: B2cLevyPrivilegeApplicationInput;
  /** A flag declaring the marketing opt in associated with the accepted offer was given. */
  marketingOptIn: Scalars['Boolean']['input'];
  /** The text for the accepted marketing opt in. This is required if the marketing opt in is given. */
  marketingText?: InputMaybe<Scalars['String']['input']>;
  /** The unique offer id of the accepted offer. */
  offerId: Scalars['String']['input'];
};

export type B2cAddVarioTariffChangeRequestInput = {
  /** Banking details to be used for direct debit payments. If this is empty, the contract will switch to bank transfers. */
  bankingDetails?: InputMaybe<B2cBankingDetailsInput>;
  /** The contract id associated with the tariff change request. */
  contractId: Scalars['Int']['input'];
  /** A flag to keep the current contracts banking details. */
  keepBankingDetails: Scalars['Boolean']['input'];
  /** Application for the levy privilege as per the §22 Law. */
  levyPrivilegeApplication: B2cLevyPrivilegeApplicationInput;
  /** A flag declaring the marketing opt in associated with the accepted offer was given. */
  marketingOptIn: Scalars['Boolean']['input'];
  /** The text for the accepted marketing opt in. This is required if the marketing opt in is given. */
  marketingText?: InputMaybe<Scalars['String']['input']>;
  /** The unique offer id of the accepted offer. */
  offerId: Scalars['String']['input'];
};

export type B2cAddWinBackTariffChangeRequestInput = {
  /** Banking details to be used for direct debit payments. If this is empty, the contract will switch to bank transfers. */
  bankingDetails?: InputMaybe<B2cBankingDetailsInput>;
  /** A Uuid to identify the resulting order. */
  clientUuid: Scalars['UUID']['input'];
  /** The customers personal details. */
  customerCommunicationData: B2cCustomerCommunicationDataInput;
  /** The customer id associated with the offer for whom a new contract order will be created. */
  customerId: Scalars['Int']['input'];
  /** The customers previous provider details. */
  deliveryData: B2cDeliveryDataInput;
  /** The text for accepting the terms and conditions, including a link to the actual terms and conditions document. */
  legalConsentText: Scalars['String']['input'];
  /** Application for the levy privilege as per the §22 Law. */
  levyPrivilegeApplication: B2cLevyPrivilegeApplicationInput;
  /** A flag declaring the marketing opt in associated with the accepted offer was given. */
  marketingOptIn: Scalars['Boolean']['input'];
  /** The text for the accepted marketing opt in. This is required if the marketing opt in is given. */
  marketingText?: InputMaybe<Scalars['String']['input']>;
  /** The unique offer id of the accepted offer. */
  offerId: Scalars['String']['input'];
};

export type B2cBankingDetailsInput = {
  /** Optional account holder for the IBAN if other than the customers name. */
  alternativeAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** IBAN to use for direct debit payments */
  iban: Scalars['String']['input'];
};

export type B2cBooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum B2cCampaignOfferType {
  ContractExtensionOffer = 'CONTRACT_EXTENSION_OFFER',
  CrossSell = 'CROSS_SELL',
  Manual = 'MANUAL',
  Retention = 'RETENTION',
  Unknown = 'UNKNOWN',
  UpSell = 'UP_SELL',
  Vario = 'VARIO',
  WinBack = 'WIN_BACK',
}

export type B2cContactRequestByContractAddressPayloadInput = {
  /** City name of the contracts address. */
  city: Scalars['String']['input'];
  /** The id of the contract for which the request is made. */
  contractId: Scalars['Int']['input'];
  /** The counter number of the contract. This field is optional and use in a special case for requests related to readings. */
  counterNumber?: InputMaybe<Scalars['String']['input']>;
  /** Email address for correspondence. May be a custom email address. */
  emailAddress: Scalars['String']['input'];
  /** The list of files that have been uploaded with this request. The list can be empty, if no files were uploaded. */
  fileIds: Array<Scalars['UUID']['input']>;
  /** First name of the customer. Does not need to be the same as the contract holder. */
  firstName: Scalars['String']['input'];
  /** House number of the contracts address. */
  houseNumber: Scalars['String']['input'];
  /** Used for B2B customers. */
  isB2B: Scalars['Boolean']['input'];
  /** Used for B2C customers. */
  isB2C: Scalars['Boolean']['input'];
  /** Last name of the customer. Does not need to be the same as the contract holder. */
  lastName: Scalars['String']['input'];
  /** HoneyPot bot protection field. */
  majaId: Scalars['Long']['input'];
  /** The message contents of the request. */
  message: Scalars['String']['input'];
  /** The phone number for correspondence. May be a custom phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Postal code of the contracts address. */
  postCode: Scalars['String']['input'];
  /** A unique ID for the request, will be used to correlate the uploaded files and ensure the request does not get duplicated. */
  requestId: Scalars['UUID']['input'];
  /** Street name of the contracts address. */
  street: Scalars['String']['input'];
  /** The routing key for CRM. */
  ticketRoutingKey: Scalars['String']['input'];
  /** The title for the request. */
  title: Scalars['String']['input'];
  /** HoneyPot bot protection field. */
  williId: Scalars['String']['input'];
};

export type B2cContactRequestByContractPayloadInput = {
  /** The id of the contract for which the request is made. */
  contractId: Scalars['Int']['input'];
  /** The counter number of the contract. This field is optional and use in a special case for requests related to readings. */
  counterNumber?: InputMaybe<Scalars['String']['input']>;
  /** The list of files that have been uploaded with this request. The list can be empty, if no files were uploaded. */
  fileIds: Array<Scalars['UUID']['input']>;
  /** HoneyPot bot protection field. */
  majaId: Scalars['Long']['input'];
  /** The message contents of the request. */
  message: Scalars['String']['input'];
  /** A unique ID for the request, will be used to correlate the uploaded files and ensure the request does not get duplicated. */
  requestId: Scalars['UUID']['input'];
  /** The routing key for CRM. */
  ticketRoutingKey: Scalars['String']['input'];
  /** The title for the request. */
  title: Scalars['String']['input'];
  /** HoneyPot bot protection field. */
  williId: Scalars['String']['input'];
};

export type B2cContactRequestForLeadsPayloadInput = {
  /** The counter number of the contract. This field is optional and use in a special case for requests related to readings. */
  counterNumber?: InputMaybe<Scalars['String']['input']>;
  /** Email address for correspondence. May be a custom email address. */
  emailAddress: Scalars['String']['input'];
  /** The list of files that have been uploaded with this request. The list can be empty, if no files were uploaded. */
  fileIds: Array<Scalars['UUID']['input']>;
  /** First name of the customer. Does not need to be the same as the contract holder. */
  firstName: Scalars['String']['input'];
  /** Last name of the customer. Does not need to be the same as the contract holder. */
  lastName: Scalars['String']['input'];
  /** HoneyPot bot protection field. */
  majaId: Scalars['Long']['input'];
  /** The message contents of the request. */
  message: Scalars['String']['input'];
  /** The phone number for correspondence. May be a custom phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for the request, will be used to correlate the uploaded files and ensure the request does not get duplicated. */
  requestId: Scalars['UUID']['input'];
  /** The routing key for CRM. */
  ticketRoutingKey: Scalars['String']['input'];
  /** The title for the request. */
  title: Scalars['String']['input'];
  /** HoneyPot bot protection field. */
  williId: Scalars['String']['input'];
};

export type B2cContractAddressPayloadInput = {
  city: Scalars['String']['input'];
  contractId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  houseNumber: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type B2cContractDetailsPayloadInput = {
  contractId: Scalars['Int']['input'];
  date: Scalars['Date']['input'];
  implausibleReading: Scalars['Boolean']['input'];
  implausibleReadingReason?: InputMaybe<Scalars['String']['input']>;
  values: Array<B2cKeyValuePairOfStringAndInt32Input>;
};

export type B2cContractMeterNumberRequestPayloadInput = {
  contractId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  meterNumber: Scalars['String']['input'];
  requestedModule: Scalars['Int']['input'];
};

export type B2cContractPayloadForTariffChangeOffersInput = {
  code: Scalars['String']['input'];
  contractId: Scalars['Int']['input'];
};

export type B2cContractRequestPayloadInput = {
  contractId: Scalars['Int']['input'];
  requestedModule: Scalars['Int']['input'];
};

export type B2cCustomerCommunicationDataInput = {
  /** The customers optional birthdate. */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** The customers e-mail address. */
  emailAddress: Scalars['String']['input'];
  /** The customers telephone number. */
  phoneMobile: Scalars['String']['input'];
};

/** To get the B2C customer you need to either be authneticated or use one of the alternative query inputs. */
export type B2cCustomerInput = {
  /** Use this input to get anonymously available customer data using the query input with the contracts address. This input does not require authentification. */
  contractAddressPayload?: InputMaybe<B2cContractAddressPayloadInput>;
  /** Use this input to get anonymously available customer data using the query input with the meter id, contract id, email, first and last name. This input does not require authentification. */
  gridFeeReductionPayload?: InputMaybe<B2cGridFeeReductionPayloadInput>;
  /** Use this input to get anonymously available customer data using the query input with a tariff change code, may it be an offer code, offer group code or an offer id. This input does not require authentification. */
  tarifChangeCodePayload?: InputMaybe<B2cTariffChangeCodePayloadInput>;
};

export type B2cCustomerPayloadForTariffChangeOffersInput = {
  code: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
};

export type B2cCustomerPayloadInput = {
  contractId: Scalars['Int']['input'];
  criticalPath: Scalars['String']['input'];
};

export type B2cDeliveryDataInput = {
  /** A flag declaring if the customer already has terminated his contract with the previous provider. */
  isTerminatedWithPreviousProvider: Scalars['Boolean']['input'];
  /** Optional market location id for the contract location. */
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  /** Meter number for the contract location. */
  meterNumber: Scalars['String']['input'];
  /** The code number of the previous provider. */
  previousProviderCode: Scalars['String']['input'];
  /** Date for which the contract has been terminated with the previous provider. */
  terminationDateWithPreviousProvider?: InputMaybe<Scalars['Date']['input']>;
};

export enum B2cFixedPriceType {
  FixedPriceTypeEnergy = 'FIXED_PRICE_TYPE_ENERGY',
  FixedPriceTypeFix = 'FIXED_PRICE_TYPE_FIX',
  FixedPriceTypeGoodwill = 'FIXED_PRICE_TYPE_GOODWILL',
  GuaranteeDate = 'GUARANTEE_DATE',
  GuaranteeDateFix = 'GUARANTEE_DATE_FIX',
  GuaranteeDateFullPriceExcludingVat = 'GUARANTEE_DATE_FULL_PRICE_EXCLUDING_VAT',
  GuaranteeDateFullPriceIncludingVatAndNewTaxes = 'GUARANTEE_DATE_FULL_PRICE_INCLUDING_VAT_AND_NEW_TAXES',
  GuaranteeDateGoodwill = 'GUARANTEE_DATE_GOODWILL',
  GuaranteeMonths = 'GUARANTEE_MONTHS',
  GuaranteeMonthsFix = 'GUARANTEE_MONTHS_FIX',
  GuaranteeMonthsFullPriceExcludingVat = 'GUARANTEE_MONTHS_FULL_PRICE_EXCLUDING_VAT',
  GuaranteeMonthsFullPriceIncludingVatAndNewTaxes = 'GUARANTEE_MONTHS_FULL_PRICE_INCLUDING_VAT_AND_NEW_TAXES',
  GuaranteeMonthsGoodwill = 'GUARANTEE_MONTHS_GOODWILL',
  None = 'NONE',
  Unknown = 'UNKNOWN',
}

export type B2cGridFeeReductionPayloadInput = {
  contractId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  meterNumber: Scalars['String']['input'];
};

export type B2cKeyValuePairOfStringAndInt32Input = {
  key: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type B2cLevyPrivilegeApplicationInput = {
  /** An flag declaring the opt in for a levy privilege application. */
  levyPrivilegeApplicationOptIn: Scalars['Boolean']['input'];
  /** The opt in text for the levy privilege application. This is required if the opt in is given. */
  levyPrivilegeApplicationOptInText?: InputMaybe<Scalars['String']['input']>;
};

export type B2cMessageFilterInput = {
  and?: InputMaybe<Array<B2cMessageFilterInput>>;
  contractId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<DateOperationFilterInput>;
  hasBeenRead?: InputMaybe<B2cBooleanOperationFilterInput>;
  id?: InputMaybe<B2cStringOperationFilterInput>;
  isInvoice?: InputMaybe<B2cBooleanOperationFilterInput>;
  or?: InputMaybe<Array<B2cMessageFilterInput>>;
  productName?: InputMaybe<B2cStringOperationFilterInput>;
  title?: InputMaybe<B2cStringOperationFilterInput>;
};

export enum B2cPeriodUnit {
  Days = 'DAYS',
  Months = 'MONTHS',
  Unknown = 'UNKNOWN',
  Weeks = 'WEEKS',
  Years = 'YEARS',
}

export type B2cPersonalDetailsInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  phoneMobile: Scalars['String']['input'];
};

export enum B2cReadingOrigin {
  ByCarrier = 'BY_CARRIER',
  ByCustomer = 'BY_CUSTOMER',
  Calculated = 'CALCULATED',
  Other = 'OTHER',
  PreviousProvider = 'PREVIOUS_PROVIDER',
  ThirdParty = 'THIRD_PARTY',
}

export enum B2cReadingQualifier {
  Estimated = 'ESTIMATED',
  ForeCast = 'FORE_CAST',
  Other = 'OTHER',
  Read = 'READ',
  Suggested = 'SUGGESTED',
  Sum = 'SUM',
  Unknown = 'UNKNOWN',
}

export enum B2cReadingTypes {
  CounterBegin = 'COUNTER_BEGIN',
  CounterEnd = 'COUNTER_END',
  Cycle = 'CYCLE',
  Estimation = 'ESTIMATION',
  IntermediateEstimation = 'INTERMEDIATE_ESTIMATION',
  InBetween = 'IN_BETWEEN',
  Manual = 'MANUAL',
  MeterAssembly = 'METER_ASSEMBLY',
  MeterDisassembly = 'METER_DISASSEMBLY',
  MovingIn = 'MOVING_IN',
  MovingOut = 'MOVING_OUT',
  NotSpecified = 'NOT_SPECIFIED',
  Unknown = 'UNKNOWN',
}

export type B2cStringOperationFilterInput = {
  and?: InputMaybe<Array<B2cStringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<B2cStringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type B2cTariffChangeCodePayloadInput = {
  code: Scalars['String']['input'];
  contractId: Scalars['Int']['input'];
};

/** To get the tariff change offers you need to either provide the contract id or the customer id together with the offer code, id or group code. */
export type B2cTariffChangeOffersInput = {
  /** The contract id and code for which the tariff change offers should be returned. */
  contractPayload?: InputMaybe<B2cContractPayloadForTariffChangeOffersInput>;
  /** The customer id and code for which the tariff change offers should be returned. */
  customerPayload?: InputMaybe<B2cCustomerPayloadForTariffChangeOffersInput>;
};

export enum B2cTerminationReason {
  BetterOffer = 'BETTER_OFFER',
  Death = 'DEATH',
  DifferentTariffDesired = 'DIFFERENT_TARIFF_DESIRED',
  MoveExistingContract = 'MOVE_EXISTING_CONTRACT',
  MoveNoDeliveryAddress = 'MOVE_NO_DELIVERY_ADDRESS',
  NotSatisfied = 'NOT_SATISFIED',
  NoReason = 'NO_REASON',
  OtherProvider = 'OTHER_PROVIDER',
  PriceAdjustment = 'PRICE_ADJUSTMENT',
}

export type B2cTerminationRequestByAddressPayloadInput = {
  /** City name of the contract address. May contain city details, ex: "Hamburg (Eimsbüttel)". */
  city: Scalars['String']['input'];
  /** The Id of the contract to terminate. */
  contractId: Scalars['Int']['input'];
  /** The customer Id associated with the termination request. */
  customerId: Scalars['Int']['input'];
  /** Email address for correspondence regarding the termination. May be a custom email address. */
  emailAddress: Scalars['String']['input'];
  /** First name of the contract holder. May be a custom name. */
  firstName: Scalars['String']['input'];
  /** House number of the contract address. */
  houseNumber: Scalars['String']['input'];
  /** Last name of the contract holder. May be a custom name. */
  lastName: Scalars['String']['input'];
  /** Postal code of the contract address. */
  postCode: Scalars['String']['input'];
  /** Street name of the contract address. */
  street: Scalars['String']['input'];
  /** Optional date when the termination should take effect. Leave empty to use the next possible termination date. */
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
  /** The reason for terminating the contract. */
  terminationReason: B2cTerminationReason;
  /** The type of contract termination (Regular, Special, Relocation). */
  terminationType: B2cTerminationType;
};

export type B2cTerminationRequestByContractPayloadInput = {
  /** The Id of the contract to terminate. */
  contractId: Scalars['Int']['input'];
  /** Optional date when the termination should take effect. Leave empty to use the next possible termination date. */
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
  /** The reason for terminating the contract. */
  terminationReason: B2cTerminationReason;
  /** The type of contract termination (Regular, Special, Relocation). */
  terminationType: B2cTerminationType;
};

export enum B2cTerminationType {
  Regular = 'REGULAR',
  Relocation = 'RELOCATION',
  Special = 'SPECIAL',
}

/** To get a Trustpilot URL you need to either provide the current customers details or a custom payload. Providing the customers details requires the call to be authenticated. Providing a custom payload can be used without authentication. */
export type B2cTrustpilotInput = {
  /** A custom payload can be used to generate the Trustpilot URL. This query can be made anonymously. */
  customPayload?: InputMaybe<B2cTrustpilotPayloadInput>;
  /** The contract id and critical path for which the Trustpilot URL will be generated. This query needs to be authenticated. */
  customerPayload?: InputMaybe<B2cCustomerPayloadInput>;
};

export type B2cTrustpilotPayloadInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  skUs: Array<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};

export type B2cUpdateCustomerInput = {
  /** Update the customers mobile phone number and date of birth. The phone number is required. */
  personalDetailsInput?: InputMaybe<B2cPersonalDetailsInput>;
};

export type BankAccountFilterInput = {
  alternativeAccountHolder?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<BankAccountFilterInput>>;
  bank?: InputMaybe<StringOperationFilterInput>;
  bic?: InputMaybe<StringOperationFilterInput>;
  directDebit?: InputMaybe<BooleanOperationFilterInput>;
  ibanObfuscated?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BankAccountFilterInput>>;
};

export type BankAccountSortInput = {
  alternativeAccountHolder?: InputMaybe<SortEnumType>;
  bank?: InputMaybe<SortEnumType>;
  bic?: InputMaybe<SortEnumType>;
  directDebit?: InputMaybe<SortEnumType>;
  ibanObfuscated?: InputMaybe<SortEnumType>;
};

export type BatteryInput = {
  capacity?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingContactInput = {
  billingCountryAlpha2Code?: InputMaybe<Scalars['String']['input']>;
  careOfRecipient?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salutation: Salutation;
  street?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum BonusCategory {
  Flex = 'FLEX',
  Instant = 'INSTANT',
  None = 'NONE',
  Regular = 'REGULAR',
}

export type BonusCategoryOperationFilterInput = {
  eq?: InputMaybe<BonusCategory>;
  in?: InputMaybe<Array<BonusCategory>>;
  neq?: InputMaybe<BonusCategory>;
  nin?: InputMaybe<Array<BonusCategory>>;
};

export type BonusFilterInput = {
  absolute?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<BonusFilterInput>>;
  category?: InputMaybe<BonusCategoryOperationFilterInput>;
  instantBonusInEur?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  newCustomerBonusInEur?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  newCustomerBonusInPercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<BonusFilterInput>>;
  percent?: InputMaybe<ComparableInt32OperationFilterInput>;
  type?: InputMaybe<BonusTypeOperationFilterInput>;
  unit?: InputMaybe<BonusUnitOperationFilterInput>;
};

export type BonusSortInput = {
  absolute?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  instantBonusInEur?: InputMaybe<SortEnumType>;
  newCustomerBonusInEur?: InputMaybe<SortEnumType>;
  newCustomerBonusInPercent?: InputMaybe<SortEnumType>;
  percent?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
};

export enum BonusType {
  FlexAbsolute = 'FLEX_ABSOLUTE',
  FlexPercentage = 'FLEX_PERCENTAGE',
  None = 'NONE',
  Regular = 'REGULAR',
  Unknown = 'UNKNOWN',
}

export type BonusTypeOperationFilterInput = {
  eq?: InputMaybe<BonusType>;
  in?: InputMaybe<Array<BonusType>>;
  neq?: InputMaybe<BonusType>;
  nin?: InputMaybe<Array<BonusType>>;
};

export enum BonusUnit {
  Euro = 'EURO',
  None = 'NONE',
  Percent = 'PERCENT',
}

export type BonusUnitOperationFilterInput = {
  eq?: InputMaybe<BonusUnit>;
  in?: InputMaybe<Array<BonusUnit>>;
  neq?: InputMaybe<BonusUnit>;
  nin?: InputMaybe<Array<BonusUnit>>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildingType {
  Detached = 'DETACHED',
  MidTerrace = 'MID_TERRACE',
  SemiDetached = 'SEMI_DETACHED',
}

export type CalculateSolarSystemOfferCompactInput = {
  annualSmartMeteringFee?: InputMaybe<Scalars['Decimal']['input']>;
  batteryCapacity?: InputMaybe<Scalars['Decimal']['input']>;
  crmRecordId?: InputMaybe<Scalars['UUID']['input']>;
  includeHeatpump: Scalars['Boolean']['input'];
  includeSmartMeter: Scalars['Boolean']['input'];
  includeWallbox: Scalars['Boolean']['input'];
  /** @deprecated Not used in calculations anymore */
  isLichtBlickCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  location: LocationDetailsCompactInput;
  numberOfSolarPanels?: InputMaybe<Scalars['Int']['input']>;
  powerConsumption: PowerConsumptionInput;
  roof: RoofDetailsInput;
  solarPackage?: InputMaybe<Scalars['String']['input']>;
};

export type CalculateSolarSystemOfferInput = {
  annualSmartMeteringFee?: InputMaybe<Scalars['Decimal']['input']>;
  /** Information about desired battery */
  battery: BatteryInput;
  crmRecordId?: InputMaybe<Scalars['UUID']['input']>;
  electricityTariff: ElectricityTariffInput;
  /** Additional hardware like Heatpump and Wallbox */
  include?: InputMaybe<Array<SolarHardwareComponentInput>>;
  includeHeatpump: Scalars['Boolean']['input'];
  includeScaffolding: Scalars['Boolean']['input'];
  includeSmartMeter: Scalars['Boolean']['input'];
  includeWallbox: Scalars['Boolean']['input'];
  /** @deprecated Not used in calculations anymore */
  isLichtBlickCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  location: LocationDetailsCompactInput;
  /** Number of solar modules for selected module id */
  panelModule: SolarHardwareComponentInput;
  powerConsumption: PowerConsumptionInput;
  roof: RoofDetailsInput;
  /** Name of the sales partner */
  salesPartner?: InputMaybe<Scalars['String']['input']>;
  /** The name of the packet in the price list */
  solarPackage?: InputMaybe<Scalars['String']['input']>;
  solarPotential: SolarPotentialInput;
};

export enum CampaignOfferType {
  Contractextensionoffer = 'CONTRACTEXTENSIONOFFER',
  Crosssell = 'CROSSSELL',
  Manual = 'MANUAL',
  Retention = 'RETENTION',
  Unknown = 'UNKNOWN',
  Upsell = 'UPSELL',
  Vario = 'VARIO',
  Winback = 'WINBACK',
}

export type CampaignTariffOfferRequestInput = {
  basePriceGross: Scalars['Decimal']['input'];
  campaign?: InputMaybe<Scalars['String']['input']>;
  cityId: Scalars['Int']['input'];
  energy: Energy;
  includeInstantBonus?: InputMaybe<Scalars['Boolean']['input']>;
  includeInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  productCode: Scalars['String']['input'];
  usage: Scalars['Int']['input'];
  usageNt?: InputMaybe<Scalars['Int']['input']>;
  workingPriceHtGross: Scalars['Decimal']['input'];
  workingPriceNtGross?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum CancellationPeriodType {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
}

export enum CancellationReason {
  Relocation = 'RELOCATION',
  Unknown = 'UNKNOWN',
}

export enum Capabilities {
  CreditCardPayable = 'CREDIT_CARD_PAYABLE',
  FreeParking = 'FREE_PARKING',
  Manual = 'MANUAL',
  NativeApp = 'NATIVE_APP',
  Nfc = 'NFC',
  Other = 'OTHER',
  QrCode = 'QR_CODE',
  ReducedParking = 'REDUCED_PARKING',
  ReferToCounter = 'REFER_TO_COUNTER',
  RemoteStartStop = 'REMOTE_START_STOP',
  RentalCarsOnly = 'RENTAL_CARS_ONLY',
  Reservable = 'RESERVABLE',
  Rfid = 'RFID',
  Roofed = 'ROOFED',
  SmsConfirmation = 'SMS_CONFIRMATION',
}

export type CapabilitiesOperationFilterInput = {
  eq?: InputMaybe<Capabilities>;
  in?: InputMaybe<Array<Capabilities>>;
  neq?: InputMaybe<Capabilities>;
  nin?: InputMaybe<Array<Capabilities>>;
};

export enum Categories {
  Article = 'ARTICLE',
  Dynamictariff = 'DYNAMICTARIFF',
  Eaas = 'EAAS',
  Fahrstrom = 'FAHRSTROM',
  Gas = 'GAS',
  Heatpump = 'HEATPUMP',
  Power = 'POWER',
  Power2Car = 'POWER2CAR',
  Service = 'SERVICE',
  Spot = 'SPOT',
  Storageheater = 'STORAGEHEATER',
  Unknown = 'UNKNOWN',
}

export type CategoriesOperationFilterInput = {
  eq?: InputMaybe<Categories>;
  in?: InputMaybe<Array<Categories>>;
  neq?: InputMaybe<Categories>;
  nin?: InputMaybe<Array<Categories>>;
};

export type CategorizedContactFormInput = {
  applicableToWebsiteForLead?: Scalars['Boolean']['input'];
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailRepeat?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isB2C: Scalars['Boolean']['input'];
  isServiceView: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  majaId: Scalars['Long']['input'];
  meterId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  williId?: InputMaybe<Scalars['String']['input']>;
};

export enum Category {
  Fast = 'FAST',
  Slow = 'SLOW',
  Unknown = 'UNKNOWN',
}

export type CategoryOperationFilterInput = {
  eq?: InputMaybe<Category>;
  in?: InputMaybe<Array<Category>>;
  neq?: InputMaybe<Category>;
  nin?: InputMaybe<Array<Category>>;
};

export type ChangeBankAccountInput = {
  /** Account holder for new IBAN if other than customer */
  alternativeAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Contract to which new IBAN should be applied */
  contractId: Scalars['Int']['input'];
  /** New IBAN */
  iban?: InputMaybe<Scalars['String']['input']>;
};

export enum ChangeBankAccountPayloadError {
  /** Ungültige Vertragsnummer */
  Invalidcontractid = 'INVALIDCONTRACTID',
  /** Ungültige IBAN */
  Invalidiban = 'INVALIDIBAN',
  /** Unbekannter Fehler */
  Undefined = 'UNDEFINED',
}

export type ChangeBillingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['Int']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum ChangeBillingAddressPayloadError {
  /** Fehler in einem der Felder */
  Fielderror = 'FIELDERROR',
  /** Wert hat die falsche Länge */
  Invalidlength = 'INVALIDLENGTH',
  /** Parameter hat ungültigen Wert */
  Invalidvalue = 'INVALIDVALUE',
  /** Unbekannter Fehler */
  Undefined = 'UNDEFINED',
  /** Wert fehlt */
  Valuenotset = 'VALUENOTSET',
}

export enum ChangeDepositNotAllowedReason {
  Finished = 'FINISHED',
  IsVario = 'IS_VARIO',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
}

export enum ChangeDepositPayloadError {
  /** Unbekannter Fehler */
  Undefined = 'UNDEFINED',
}

export enum ChangePasswordErrorType {
  InvalidUsernameOrPassword = 'INVALID_USERNAME_OR_PASSWORD',
  None = 'NONE',
}

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum ChargeLogStatus {
  FailedToStart = 'FAILED_TO_START',
  FailedToStop = 'FAILED_TO_STOP',
  Started = 'STARTED',
  Starting = 'STARTING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING',
  Unknown = 'UNKNOWN',
}

export enum ChargingScheduleStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Pending = 'PENDING',
  Requested = 'REQUESTED',
  Unknown = 'UNKNOWN',
}

export type ChargingScheduleStatusOperationFilterInput = {
  eq?: InputMaybe<ChargingScheduleStatus>;
  in?: InputMaybe<Array<ChargingScheduleStatus>>;
  neq?: InputMaybe<ChargingScheduleStatus>;
  nin?: InputMaybe<Array<ChargingScheduleStatus>>;
};

export enum ChargingTransactionStatus {
  ChargingStarted = 'CHARGING_STARTED',
  Finished = 'FINISHED',
  Plugged = 'PLUGGED',
  Unknown = 'UNKNOWN',
}

export type ChargingTransactionStatusOperationFilterInput = {
  eq?: InputMaybe<ChargingTransactionStatus>;
  in?: InputMaybe<Array<ChargingTransactionStatus>>;
  neq?: InputMaybe<ChargingTransactionStatus>;
  nin?: InputMaybe<Array<ChargingTransactionStatus>>;
};

export type CheckEmobilityPermissionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type CirranticFormatFilterInput = {
  amperage?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<CirranticFormatFilterInput>>;
  format?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CirranticFormatFilterInput>>;
  power?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  powerType?: InputMaybe<StringOperationFilterInput>;
  standard?: InputMaybe<StringOperationFilterInput>;
};

export type CityFilterInput = {
  and?: InputMaybe<Array<CityFilterInput>>;
  cityId?: InputMaybe<ComparableInt64OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CityFilterInput>>;
  streets?: InputMaybe<ListFilterInputTypeOfStreetFilterInput>;
};

export type CitySortInput = {
  cityId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum CollectStopChargingErrorFeedbackErrorType {
  ChargeDetailRecordNotFound = 'CHARGE_DETAIL_RECORD_NOT_FOUND',
  HtbChargeLogNotFound = 'HTB_CHARGE_LOG_NOT_FOUND',
  None = 'NONE',
  UserNotFound = 'USER_NOT_FOUND',
}

export enum CommodityContractStatus {
  Active = 'ACTIVE',
  CancellationPreviousProvider = 'CANCELLATION_PREVIOUS_PROVIDER',
  DeliveryNet = 'DELIVERY_NET',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Revoked = 'REVOKED',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING',
}

export type CommunicationFilterInput = {
  and?: InputMaybe<Array<CommunicationFilterInput>>;
  archiveId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  externalIdentifiers?: InputMaybe<ExternalIdentifiersFilterInput>;
  hasBeenRead?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isEasyArchive?: InputMaybe<BooleanOperationFilterInput>;
  messageId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommunicationFilterInput>>;
  sent?: InputMaybe<ComparableInt32OperationFilterInput>;
  sentAt?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type CommunicationSortInput = {
  archiveId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  externalIdentifiers?: InputMaybe<ExternalIdentifiersSortInput>;
  hasBeenRead?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEasyArchive?: InputMaybe<SortEnumType>;
  messageId?: InputMaybe<SortEnumType>;
  sent?: InputMaybe<SortEnumType>;
  sentAt?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export type ComparableDateTimeOffsetOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ComparableDoubleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type ComparableGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<Scalars['UUID']['input']>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type ComparableInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<Scalars['Long']['input']>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<Scalars['Long']['input']>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type ComparableNullableOfDateOnlyOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type ComparableNullableOfDateTimeOffsetOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableNullableOfDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ComparableNullableOfDoubleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type ComparableNullableOfGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ComparableNullableOfInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type ComparableNullableOfSingleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type ComparableNullableOfTimeOnlyOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalTime']['input']>;
  gt?: InputMaybe<Scalars['LocalTime']['input']>;
  gte?: InputMaybe<Scalars['LocalTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalTime']['input']>>>;
  lt?: InputMaybe<Scalars['LocalTime']['input']>;
  lte?: InputMaybe<Scalars['LocalTime']['input']>;
  neq?: InputMaybe<Scalars['LocalTime']['input']>;
  ngt?: InputMaybe<Scalars['LocalTime']['input']>;
  ngte?: InputMaybe<Scalars['LocalTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalTime']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalTime']['input']>;
  nlte?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type ConfirmOrderInput = {
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  marketingText?: InputMaybe<Scalars['String']['input']>;
  optIn?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['Int']['input'];
};

export enum ConfirmOrderPayloadError {
  Undefined = 'UNDEFINED',
}

/** A plug is either a socket (user plugs a cable in) or a non-detachable cable the user takes to put into a socket mounted in the car. */
export type ConnectorFilterInput = {
  and?: InputMaybe<Array<ConnectorFilterInput>>;
  cirranticFormat?: InputMaybe<CirranticFormatFilterInput>;
  /** The format of the plug including standard, thether, power, and category. */
  format?: InputMaybe<FormatFilterInput>;
  htbFormat?: InputMaybe<HtbFormatFilterInput>;
  or?: InputMaybe<Array<ConnectorFilterInput>>;
  properties?: InputMaybe<StringOperationFilterInput>;
};

export enum ConnectorStatus {
  Available = 'AVAILABLE',
  Charging = 'CHARGING',
  Outoforder = 'OUTOFORDER',
  Reserved = 'RESERVED',
  Unknown = 'UNKNOWN',
}

export type ConnectorStatusOperationFilterInput = {
  eq?: InputMaybe<ConnectorStatus>;
  in?: InputMaybe<Array<ConnectorStatus>>;
  neq?: InputMaybe<ConnectorStatus>;
  nin?: InputMaybe<Array<ConnectorStatus>>;
};

export enum ConsumptionType {
  HeatPump = 'HEAT_PUMP',
  HouseholdElectricity = 'HOUSEHOLD_ELECTRICITY',
  HouseholdElectricityAndHeatPump = 'HOUSEHOLD_ELECTRICITY_AND_HEAT_PUMP',
  HouseholdElectricityAndStorageHeater = 'HOUSEHOLD_ELECTRICITY_AND_STORAGE_HEATER',
  None = 'NONE',
  NonCommodity = 'NON_COMMODITY',
  StorageHeater = 'STORAGE_HEATER',
  Universal = 'UNIVERSAL',
  Unknown = 'UNKNOWN',
}

export type ConsumptionTypeOperationFilterInput = {
  eq?: InputMaybe<ConsumptionType>;
  in?: InputMaybe<Array<ConsumptionType>>;
  neq?: InputMaybe<ConsumptionType>;
  nin?: InputMaybe<Array<ConsumptionType>>;
};

export type ContactFormInput = {
  /** ContractId. NULL if none selected */
  contractId?: InputMaybe<Scalars['Int']['input']>;
  /** Message from the customer */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Selected Topic for this form */
  topic?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactFormReasonType {
  /** @deprecated Accessibility is removed from the contact reasons. */
  Accessibility = 'ACCESSIBILITY',
  AdvancePayment = 'ADVANCE_PAYMENT',
  AppFeedbackWishes = 'APP_FEEDBACK_WISHES',
  CombinedHeatPowerOffshoreLevy = 'COMBINED_HEAT_POWER_OFFSHORE_LEVY',
  DataProtection = 'DATA_PROTECTION',
  Electromobility = 'ELECTROMOBILITY',
  GasAndElectricityPriceCap = 'GAS_AND_ELECTRICITY_PRICE_CAP',
  Invoice = 'INVOICE',
  MeterReading = 'METER_READING',
  MyData = 'MY_DATA',
  Other = 'OTHER',
  PriceAdjustment = 'PRICE_ADJUSTMENT',
  Relocation = 'RELOCATION',
  Reminder = 'REMINDER',
  SolarPackageAndPowerWallet = 'SOLAR_PACKAGE_AND_POWER_WALLET',
  SubmitFinalBill = 'SUBMIT_FINAL_BILL',
  TariffAndContract = 'TARIFF_AND_CONTRACT',
  TariffChangeNet = 'TARIFF_CHANGE_NET',
  TechProblems = 'TECH_PROBLEMS',
  Termination = 'TERMINATION',
}

export enum ContactFormReasonsStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
}

export type ContactInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailBusiness?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneBusiness?: InputMaybe<Scalars['String']['input']>;
  salutation: Salutation;
  street?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPermissionByTokenInput = {
  contractRelatedProducts: Scalars['Boolean']['input'];
  customerId: Scalars['Int']['input'];
  emailEMobility: Scalars['Boolean']['input'];
  emailGas: Scalars['Boolean']['input'];
  emailMarketResearch: Scalars['Boolean']['input'];
  emailNewsletter: Scalars['Boolean']['input'];
  emailPower: Scalars['Boolean']['input'];
  emailPower2Heat: Scalars['Boolean']['input'];
  emailReferral: Scalars['Boolean']['input'];
  emailSolar: Scalars['Boolean']['input'];
};

export type ContactPermissionInput = {
  allContactBlocked: Scalars['Boolean']['input'];
  contractRelatedProducts: Scalars['Boolean']['input'];
  emailEMobility: Scalars['Boolean']['input'];
  emailGas: Scalars['Boolean']['input'];
  emailMarketResearch: Scalars['Boolean']['input'];
  emailNewsletter: Scalars['Boolean']['input'];
  emailPower: Scalars['Boolean']['input'];
  emailPower2Heat: Scalars['Boolean']['input'];
  emailReferral: Scalars['Boolean']['input'];
  emailSolar: Scalars['Boolean']['input'];
  phoneEMobility: Scalars['Boolean']['input'];
  phoneGas: Scalars['Boolean']['input'];
  phoneMarketResearch: Scalars['Boolean']['input'];
  phonePower: Scalars['Boolean']['input'];
  phonePower2Heat: Scalars['Boolean']['input'];
  phoneReferral: Scalars['Boolean']['input'];
  phoneSolar: Scalars['Boolean']['input'];
  postalMail: Scalars['Boolean']['input'];
};

export enum ContactPermissionStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type ContractFilterInput = {
  address?: InputMaybe<AddressFilterInput>;
  and?: InputMaybe<Array<ContractFilterInput>>;
  bankAccount?: InputMaybe<BankAccountFilterInput>;
  billingAddress?: InputMaybe<AddressFilterInput>;
  cancellationPeriod?: InputMaybe<PeriodFilterInput>;
  cancellationReason?: InputMaybe<NullableOfCancellationReasonOperationFilterInput>;
  communications?: InputMaybe<ListFilterInputTypeOfCommunicationFilterInput>;
  counter?: InputMaybe<CounterFilterInput>;
  createdAt?: InputMaybe<ComparableNullableOfDateOnlyOperationFilterInput>;
  customerSpecification?: InputMaybe<NullableOfCustomerSpecificationsOperationFilterInput>;
  deliveryStartConfirmedByCarrier?: InputMaybe<ComparableNullableOfDateOnlyOperationFilterInput>;
  deliveryStartRequestSentToCarrier?: InputMaybe<ComparableNullableOfDateOnlyOperationFilterInput>;
  depositCalculated?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  depositMax?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  depositMin?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deposits?: InputMaybe<ListFilterInputTypeOfDepositFilterInput>;
  endDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  energy?: InputMaybe<StringOperationFilterInput>;
  extensionTime?: InputMaybe<PeriodFilterInput>;
  externalIdentifiers?: InputMaybe<ExternalIdentifiersFilterInput>;
  externalOrderId?: InputMaybe<StringOperationFilterInput>;
  futureDeposits?: InputMaybe<ListFilterInputTypeOfFutureDepositFilterInput>;
  gridFeeReductionModule?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  hasLevyPrivilegeReductionApplication?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  invoicePeriodEndDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  invoices?: InputMaybe<ListFilterInputTypeOfInvoiceFilterInput>;
  marketLocationId?: InputMaybe<StringOperationFilterInput>;
  minimumRuntime?: InputMaybe<PeriodFilterInput>;
  nextCancellationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  nextPossibleEndDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContractFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  relocationPossible?: InputMaybe<BooleanOperationFilterInput>;
  relocationPredecessorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  revocationDate?: InputMaybe<ComparableNullableOfDateOnlyOperationFilterInput>;
  startDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  status?: InputMaybe<NullableOfContractStatusOperationFilterInput>;
  statuses?: InputMaybe<ListFilterInputTypeOfContractStatusHistoryFilterInput>;
  tariffs?: InputMaybe<ListFilterInputTypeOfTariffFilterInput>;
  terminationDate?: InputMaybe<ComparableNullableOfDateOnlyOperationFilterInput>;
  terminationSentToPreviousProvider?: InputMaybe<ComparableNullableOfDateOnlyOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  usage?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ContractPriceInput = {
  priceType?: InputMaybe<Scalars['String']['input']>;
  quantityFrom?: InputMaybe<Scalars['Int']['input']>;
  tariffTimeFrames: ContractPriceTariffTimeFrame;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export enum ContractPriceTariffTimeFrame {
  Anytime = 'ANYTIME',
  Unknown = 'UNKNOWN',
}

export type ContractSortInput = {
  address?: InputMaybe<AddressSortInput>;
  bankAccount?: InputMaybe<BankAccountSortInput>;
  billingAddress?: InputMaybe<AddressSortInput>;
  cancellationPeriod?: InputMaybe<PeriodSortInput>;
  cancellationReason?: InputMaybe<SortEnumType>;
  counter?: InputMaybe<CounterSortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  customerSpecification?: InputMaybe<SortEnumType>;
  deliveryStartConfirmedByCarrier?: InputMaybe<SortEnumType>;
  deliveryStartRequestSentToCarrier?: InputMaybe<SortEnumType>;
  depositCalculated?: InputMaybe<SortEnumType>;
  depositMax?: InputMaybe<SortEnumType>;
  depositMin?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  energy?: InputMaybe<SortEnumType>;
  extensionTime?: InputMaybe<PeriodSortInput>;
  externalIdentifiers?: InputMaybe<ExternalIdentifiersSortInput>;
  externalOrderId?: InputMaybe<SortEnumType>;
  gridFeeReductionModule?: InputMaybe<SortEnumType>;
  hasLevyPrivilegeReductionApplication?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invoicePeriodEndDate?: InputMaybe<SortEnumType>;
  marketLocationId?: InputMaybe<SortEnumType>;
  minimumRuntime?: InputMaybe<PeriodSortInput>;
  nextCancellationDate?: InputMaybe<SortEnumType>;
  nextPossibleEndDate?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  product?: InputMaybe<ProductSortInput>;
  relocationPossible?: InputMaybe<SortEnumType>;
  relocationPredecessorId?: InputMaybe<SortEnumType>;
  revocationDate?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  terminationDate?: InputMaybe<SortEnumType>;
  terminationSentToPreviousProvider?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  usage?: InputMaybe<SortEnumType>;
};

export enum ContractStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Cancellationpreviousprovider = 'CANCELLATIONPREVIOUSPROVIDER',
  Cancelled = 'CANCELLED',
  Deliverynet = 'DELIVERYNET',
  Done = 'DONE',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Revoked = 'REVOKED',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING',
}

export enum ContractStatusBadge {
  Expired = 'EXPIRED',
  InDelivery = 'IN_DELIVERY',
  InProgress = 'IN_PROGRESS',
  Relocated = 'RELOCATED',
  RelocationConfirmed = 'RELOCATION_CONFIRMED',
  Revoked = 'REVOKED',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
}

export enum ContractStatusChangingReason {
  Activating = 'ACTIVATING',
  Deactivating = 'DEACTIVATING',
  Unknown = 'UNKNOWN',
}

export type ContractStatusHistoryFilterInput = {
  and?: InputMaybe<Array<ContractStatusHistoryFilterInput>>;
  or?: InputMaybe<Array<ContractStatusHistoryFilterInput>>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  status?: InputMaybe<ContractStatusOperationFilterInput>;
};

export type ContractStatusHistorySortInput = {
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type ContractStatusOperationFilterInput = {
  eq?: InputMaybe<ContractStatus>;
  in?: InputMaybe<Array<ContractStatus>>;
  neq?: InputMaybe<ContractStatus>;
  nin?: InputMaybe<Array<ContractStatus>>;
};

export enum CostItemType {
  CpoCosts = 'CPO_COSTS',
  Custom = 'CUSTOM',
  DurationMinute = 'DURATION_MINUTE',
  Energy = 'ENERGY',
  Flat = 'FLAT',
  Service = 'SERVICE',
  TariffCalcChargingTimeCosts = 'TARIFF_CALC_CHARGING_TIME_COSTS',
  TariffCalcEnergyCosts = 'TARIFF_CALC_ENERGY_COSTS',
  TariffCalcFlatCosts = 'TARIFF_CALC_FLAT_COSTS',
  TariffCalcIdleTimeCosts = 'TARIFF_CALC_IDLE_TIME_COSTS',
  TariffCalcReservationCosts = 'TARIFF_CALC_RESERVATION_COSTS',
  UnKnown = 'UN_KNOWN',
}

export type CounterFilterInput = {
  activeFrom?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  activeUntil?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  and?: InputMaybe<Array<CounterFilterInput>>;
  counterNumber?: InputMaybe<StringOperationFilterInput>;
  counterType?: InputMaybe<CounterTypeOperationFilterInput>;
  id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<CounterFilterInput>>;
  registers?: InputMaybe<ListFilterInputTypeOfRegisterFilterInput>;
};

export type CounterSortInput = {
  activeFrom?: InputMaybe<SortEnumType>;
  activeUntil?: InputMaybe<SortEnumType>;
  counterNumber?: InputMaybe<SortEnumType>;
  counterType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export enum CounterType {
  Etz = 'ETZ',
  Ntz = 'NTZ',
  Unknown = 'UNKNOWN',
  Ztz = 'ZTZ',
}

export type CounterTypeOperationFilterInput = {
  eq?: InputMaybe<CounterType>;
  in?: InputMaybe<Array<CounterType>>;
  neq?: InputMaybe<CounterType>;
  nin?: InputMaybe<Array<CounterType>>;
};

export type CreateMarketingLeadInput = {
  lead: MarketingLeadDtoInput;
};

export type CreateOrderExtendedRequestInput = {
  alternativeAccountHolder?: InputMaybe<Scalars['String']['input']>;
  billingContact?: InputMaybe<BillingContactInput>;
  contact?: InputMaybe<ContactInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  delayUntil?: InputMaybe<Scalars['DateTime']['input']>;
  eventMetadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  extendedData?: InputMaybe<Scalars['String']['input']>;
  gridFeeModule?: InputMaybe<PowerCloudGridFeeModule>;
  iban?: InputMaybe<Scalars['String']['input']>;
  marketingData?: InputMaybe<MarketingDataInput>;
  nonCommodityOrders?: InputMaybe<Array<InputMaybe<NonCommodityOrderExtendedInput>>>;
  orders?: InputMaybe<Array<InputMaybe<OrderExtendedInput>>>;
  skipCustomerRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  uvpCode?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  vpCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderRequestInput = {
  alternativeAccountHolder?: InputMaybe<Scalars['String']['input']>;
  billingContact?: InputMaybe<BillingContactInput>;
  contact?: InputMaybe<ContactInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  eventMetadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  extendedData?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  marketingData?: InputMaybe<MarketingDataInput>;
  nonCommodityOrders?: InputMaybe<Array<InputMaybe<NonCommodityOrderInput>>>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  uvpCode?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  vpCode?: InputMaybe<Scalars['String']['input']>;
};

export enum CreateOrderStatus {
  Ok = 'OK',
}

export type CreateRelocationOrderInput = {
  /** Arrival date to which customer wishes to start this order in international format (YYYY-MM-DD). */
  arrivalDate: Scalars['DateTime']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['Int']['input'];
  counterNumber?: InputMaybe<Scalars['String']['input']>;
  /** Date of departure in international format (YYYY-MM-DD). */
  departureDate: Scalars['DateTime']['input'];
  deposit?: InputMaybe<Scalars['Float']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  relocationAddressTransfer: RelocationAddressTransfer;
  street?: InputMaybe<Scalars['String']['input']>;
  /** New yearly usage in kWh (only as an alternative to HT/NT yearly usage). This field is mandatory if yearlyUsageHt/yearlyUsageNt is not given. */
  yearlyUsage?: InputMaybe<Scalars['Float']['input']>;
  /** New yearly HT-usage in kWh (only as an alternative to the yearlyUsage). */
  yearlyUsageHt?: InputMaybe<Scalars['Float']['input']>;
  /** New yearly NT-usage in kWh (only as an alternative to the yearlyUsage). Mandatory if yearlyUsageHt is given. */
  yearlyUsageNt?: InputMaybe<Scalars['Float']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum CreateRelocationOrderPayloadError {
  Contractcannotberelocated = 'CONTRACTCANNOTBERELOCATED',
  Fielderrors = 'FIELDERRORS',
  Invalidpastdate = 'INVALIDPASTDATE',
  Invalidusage = 'INVALIDUSAGE',
  Missingvalue = 'MISSINGVALUE',
  Unknown = 'UNKNOWN',
  Unknowncity = 'UNKNOWNCITY',
}

export type CreateSolarPanelInstallationLeadInput = {
  lead: SolarPanelInstallationLeadInput;
};

export enum CurrentEaasSubscriptionDataErrorType {
  IncompleteData = 'INCOMPLETE_DATA',
  None = 'NONE',
  UnhandledError = 'UNHANDLED_ERROR',
}

export enum CustomerContactFormStatus {
  Contractmissing = 'CONTRACTMISSING',
  Error = 'ERROR',
  Honeypot = 'HONEYPOT',
  Invalidparameters = 'INVALIDPARAMETERS',
  Limitexceeded = 'LIMITEXCEEDED',
  Success = 'SUCCESS',
}

export type CustomerInput = {
  /** Optional date of Birth, if changed */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Optional phone mobile, if changed */
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  /** Optional phone mobile area code, if changed */
  phoneMobileAreaCode?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerSpecification {
  DesiredDate = 'DESIRED_DATE',
  EarliestPossibleDate = 'EARLIEST_POSSIBLE_DATE',
  RelocationAt = 'RELOCATION_AT',
  TerminatedInPerson = 'TERMINATED_IN_PERSON',
}

export enum CustomerSpecifications {
  Basicsupplyregistration = 'BASICSUPPLYREGISTRATION',
  Desireddate = 'DESIREDDATE',
  Earliestpossibledate = 'EARLIESTPOSSIBLEDATE',
  Relocationat = 'RELOCATIONAT',
  Relocationwithoutmako = 'RELOCATIONWITHOUTMAKO',
  Substitutesupplyregistration = 'SUBSTITUTESUPPLYREGISTRATION',
  Terminatedinperson = 'TERMINATEDINPERSON',
  Unknown = 'UNKNOWN',
}

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeactivateSmartChargingInput = {
  evseId: Scalars['UUID']['input'];
};

export enum DeleteUserAccountStatus {
  Ok = 'OK',
}

export type DepositFilterInput = {
  activeFrom?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  activeUntil?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<DepositFilterInput>>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  createdByOrigin?: InputMaybe<OriginsOperationFilterInput>;
  grossAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  netAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  nextExecutionAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  nextExecutionFor?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DepositFilterInput>>;
  taxAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  taxRate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  updatedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  updatedByOrigin?: InputMaybe<OriginsOperationFilterInput>;
};

export type DepositInput = {
  /** Date from which this deposit change is active */
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Day of month on which the deposit is payable */
  alternativeDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Contract id for this deposit */
  contractId: Scalars['Int']['input'];
  /** New monthly deposit value */
  value: Scalars['Float']['input'];
};

export enum DesiredTimeOfInstallation {
  In1_3Months = 'IN1_3_MONTHS',
  In4_6Months = 'IN4_6_MONTHS',
  In6MonthsAtTheEarliest = 'IN6_MONTHS_AT_THE_EARLIEST',
  NextAvailableTime = 'NEXT_AVAILABLE_TIME',
}

export enum DisbursementType {
  Onetime = 'ONETIME',
  Permanent = 'PERMANENT',
}

export type DynamicTariffCurrentMonthRunningCostsInput = {
  powerCloudContractId: Scalars['Int']['input'];
};

export type DynamicTariffRunningCostsTechInput = {
  contractId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
};

/** Calculate StromWallet for existing system */
export type EaasCalculateStromWalletOfferBasicInput = {
  crmRecordId?: InputMaybe<Scalars['String']['input']>;
  electricityConsumption: PowerConsumptionInput;
  /** Amount of Energy (KWh) Purchased from the grid */
  gridSupply: Scalars['Decimal']['input'];
  postalCode: Scalars['String']['input'];
  /** PowerOutput of PV system in KWp (6.0 instead of 6000) */
  pvSystemOutput: Scalars['Decimal']['input'];
  /** The name of the packet in the price list */
  solarPackage: Scalars['String']['input'];
};

/** Calculate StromWallet for existing system */
export type EaasCalculateStromWalletOfferInput = {
  /** Total energy storage capacity of the system, in kWh. For example: 10.5 */
  batteryCapacity: Scalars['Decimal']['input'];
  crmRecordId?: InputMaybe<Scalars['String']['input']>;
  electricityConsumption: PowerConsumptionInput;
  electricityTariff: ElectricityTariffInput;
  /** Total Price to calculate amortization time. Might include all hardware, installation price, etc */
  existingSystemPrice: Scalars['Decimal']['input'];
  /** Amount of Energy (KWh) Purchased from the grid */
  gridSupply?: InputMaybe<Scalars['Decimal']['input']>;
  /** Number of solar panels in the system */
  numberOfPvPanels: Scalars['Int']['input'];
  postalCode: Scalars['String']['input'];
  /** PowerOutput of single panel, in Watts. For example: 450 */
  pvPanelPowerOutput: Scalars['Int']['input'];
  roof: RoofDetailsInput;
  /** Name of the sales partner */
  salesPartner?: InputMaybe<Scalars['String']['input']>;
  /** The name of the packet in the price list */
  solarPackage: Scalars['String']['input'];
  /** Solar potential or Average Radiation Amount */
  solarPotential: SolarPotentialInput;
};

export type EaasCurrentSubscriptionDataInput = {
  subscriptionId: Scalars['String']['input'];
};

export type EaasDailyHistoricalDataInput = {
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  subscriptionId: Scalars['UUID']['input'];
};

export enum EaasEnergyContractTypePayload {
  DynamicPro = 'DYNAMIC_PRO',
  None = 'NONE',
  Other = 'OTHER',
  Vario = 'VARIO',
}

export type EaasEvsesPayloadFilterInput = {
  and?: InputMaybe<Array<EaasEvsesPayloadFilterInput>>;
  chargingLogic?: InputMaybe<EvseChargingLogicOperationFilterInput>;
  chargingMode?: InputMaybe<EvseChargingModeOperationFilterInput>;
  id?: InputMaybe<ComparableGuidOperationFilterInput>;
  isChargingLogicChanging?: InputMaybe<BooleanOperationFilterInput>;
  isSmartChargingScheduleRepeatableDaily?: InputMaybe<BooleanOperationFilterInput>;
  latestChargingTransaction?: InputMaybe<LatestEaasChargingTransactionFilterInput>;
  manufacturer?: InputMaybe<StringOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EaasEvsesPayloadFilterInput>>;
  requestedSmartChargingEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  requestedSmartChargingEndTime?: InputMaybe<ComparableNullableOfTimeOnlyOperationFilterInput>;
  requestedSmartChargingEnergyWh?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  smartChargingSchedule?: InputMaybe<SmartChargingScheduleFilterInput>;
  status?: InputMaybe<LbEvseStatusOperationFilterInput>;
  supportsScheduleBasedCharging?: InputMaybe<BooleanOperationFilterInput>;
};

export type EaasHistoricIndependenceInput = {
  numberOfDays?: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type EaasHourlyHistoricalDataInput = {
  intervalEnd?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['UUID']['input'];
};

export type EaasIndependenceRatesInput = {
  subscriptionId: Scalars['UUID']['input'];
};

export type EaasLatestQuarterHourDataInput = {
  subscriptionId: Scalars['UUID']['input'];
};

export enum EaasPaymentType {
  BankTransfer = 'BANK_TRANSFER',
  DirectDebit = 'DIRECT_DEBIT',
  Undefined = 'UNDEFINED',
}

export enum EaasStromWalletActivationStatusPayload {
  MeterConfigured = 'METER_CONFIGURED',
  SwitchedToDynamic = 'SWITCHED_TO_DYNAMIC',
  SwitchedToVario = 'SWITCHED_TO_VARIO',
  Undefined = 'UNDEFINED',
  WaitingForVarioConfirmation = 'WAITING_FOR_VARIO_CONFIRMATION',
}

export enum EaasStromWalletPackagePayload {
  SolarPaketLight = 'SOLAR_PAKET_LIGHT',
  SolarPaketString = 'SOLAR_PAKET_STRING',
  StromWallet1 = 'STROM_WALLET1',
  StromWallet2 = 'STROM_WALLET2',
  StromWalletOnly = 'STROM_WALLET_ONLY',
  StromWalletUpsell = 'STROM_WALLET_UPSELL',
  Undefined = 'UNDEFINED',
}

export enum EaasSubscriptionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN',
}

export enum EaasUserType {
  ActivatedEaasUser = 'ACTIVATED_EAAS_USER',
  NotActivatedEaasUser = 'NOT_ACTIVATED_EAAS_USER',
  NotEaasUser = 'NOT_EAAS_USER',
}

export enum EeecActivateChargeCardResultType {
  ChargeCardIsAlreadyAssigned = 'CHARGE_CARD_IS_ALREADY_ASSIGNED',
  Failed = 'FAILED',
  InvalidEvcoId = 'INVALID_EVCO_ID',
  Success = 'SUCCESS',
  UserNotFound = 'USER_NOT_FOUND',
}

export enum EeecActivateTokenResultType {
  Failed = 'FAILED',
  InvalidEvcoId = 'INVALID_EVCO_ID',
  Success = 'SUCCESS',
  TokenIsAlreadyAssigned = 'TOKEN_IS_ALREADY_ASSIGNED',
  UserNotFound = 'USER_NOT_FOUND',
}

export enum EeecAddFavouriteResult {
  Error = 'ERROR',
  LocationAlreadyInFavourites = 'LOCATION_ALREADY_IN_FAVOURITES',
  Success = 'SUCCESS',
}

export type EeecAddressInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryIso: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type EeecCartItemInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type EeecClusterFiltersInput = {
  availableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  companyLocationsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  connectorStandardTypes?: InputMaybe<Array<EeecConnectorStandardType>>;
  maximumPowerKw?: InputMaybe<Scalars['Int']['input']>;
  minimumPowerKw: Scalars['Int']['input'];
};

export enum EeecConnectorPowerType {
  Ac_1Phase = 'AC_1_PHASE',
  Ac_2Phase = 'AC_2_PHASE',
  Ac_2PhaseSplit = 'AC_2_PHASE_SPLIT',
  Ac_3Phase = 'AC_3_PHASE',
  Dc = 'DC',
}

export enum EeecConnectorStandard {
  Chademo = 'CHADEMO',
  Chaoji = 'CHAOJI',
  DomesticA = 'DOMESTIC_A',
  DomesticB = 'DOMESTIC_B',
  DomesticC = 'DOMESTIC_C',
  DomesticD = 'DOMESTIC_D',
  DomesticE = 'DOMESTIC_E',
  DomesticF = 'DOMESTIC_F',
  DomesticG = 'DOMESTIC_G',
  DomesticH = 'DOMESTIC_H',
  DomesticI = 'DOMESTIC_I',
  DomesticJ = 'DOMESTIC_J',
  DomesticK = 'DOMESTIC_K',
  DomesticL = 'DOMESTIC_L',
  DomesticM = 'DOMESTIC_M',
  DomesticN = 'DOMESTIC_N',
  DomesticO = 'DOMESTIC_O',
  GbtAc = 'GBT_AC',
  GbtDc = 'GBT_DC',
  Iec_60309_2Single_16 = 'IEC_60309_2_SINGLE_16',
  Iec_60309_2Three_16 = 'IEC_60309_2_THREE_16',
  Iec_60309_2Three_32 = 'IEC_60309_2_THREE_32',
  Iec_60309_2Three_64 = 'IEC_60309_2_THREE_64',
  Iec_62196T1 = 'IEC_62196_T1',
  Iec_62196T1Combo = 'IEC_62196_T1_COMBO',
  Iec_62196T2 = 'IEC_62196_T2',
  Iec_62196T2Combo = 'IEC_62196_T2_COMBO',
  Iec_62196T3A = 'IEC_62196_T3A',
  Iec_62196T3C = 'IEC_62196_T3C',
  Mcs = 'MCS',
  Nema_5_20 = 'NEMA_5_20',
  Nema_6_30 = 'NEMA_6_30',
  Nema_6_50 = 'NEMA_6_50',
  Nema_10_30 = 'NEMA_10_30',
  Nema_10_50 = 'NEMA_10_50',
  Nema_14_30 = 'NEMA_14_30',
  Nema_14_50 = 'NEMA_14_50',
  PantographBottomUp = 'PANTOGRAPH_BOTTOM_UP',
  PantographTopDown = 'PANTOGRAPH_TOP_DOWN',
  SaeJ3400 = 'SAE_J3400',
  TeslaR = 'TESLA_R',
  TeslaS = 'TESLA_S',
}

export enum EeecConnectorStandardType {
  Ccs = 'CCS',
  Chademo = 'CHADEMO',
  Other = 'OTHER',
  Type2 = 'TYPE2',
}

export type EeecCreateEDriverRequestInput = {
  email: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export enum EeecCreateEDriverResultType {
  InvalidSource = 'INVALID_SOURCE',
  NewUserRegistrationNotAllowed = 'NEW_USER_REGISTRATION_NOT_ALLOWED',
  UserAlreadyExists = 'USER_ALREADY_EXISTS',
  UserBlocked = 'USER_BLOCKED',
  UserCreatedWithSsoSupport = 'USER_CREATED_WITH_SSO_SUPPORT',
  UserCreationFailed = 'USER_CREATION_FAILED',
  UserCreationInitiated = 'USER_CREATION_INITIATED',
}

export type EeecCreateVehicleRequestInput = {
  assignmentPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  assignmentPeriodStart: Scalars['DateTime']['input'];
  licensePlate: Scalars['String']['input'];
};

export enum EeecEmailVerificationResultType {
  AlreadyVerified = 'ALREADY_VERIFIED',
  BusinessEmailNotSet = 'BUSINESS_EMAIL_NOT_SET',
  InvalidVerificationCode = 'INVALID_VERIFICATION_CODE',
  OperationNotAllowed = 'OPERATION_NOT_ALLOWED',
  Success = 'SUCCESS',
  UserNotFound = 'USER_NOT_FOUND',
}

export enum EeecEvseStatus {
  Available = 'AVAILABLE',
  Blocked = 'BLOCKED',
  Charging = 'CHARGING',
  Inoperative = 'INOPERATIVE',
  Outoforder = 'OUTOFORDER',
  Planned = 'PLANNED',
  Removed = 'REMOVED',
  Reserved = 'RESERVED',
  Unknown = 'UNKNOWN',
}

export enum EeecFinalizeOnboardingResultType {
  Failed = 'FAILED',
  OperationNotAllowed = 'OPERATION_NOT_ALLOWED',
  Success = 'SUCCESS',
}

export type EeecLeasingContractDetailsInput = {
  companyRegistrationOptionId: Scalars['String']['input'];
  employeeNumber: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
};

export type EeecMagicLinkRequestInput = {
  clientId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type EeecMeterReadingInput = {
  readingDate: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
};

export enum EeecMileageLogCreationResponse {
  FailureMileageLogLowerThanLastLog = 'FAILURE_MILEAGE_LOG_LOWER_THAN_LAST_LOG',
  FailureVehicleDoesNotBelongToUser = 'FAILURE_VEHICLE_DOES_NOT_BELONG_TO_USER',
  FailureVehicleNotFound = 'FAILURE_VEHICLE_NOT_FOUND',
  Success = 'SUCCESS',
}

export type EeecOrderRequestInput = {
  cartItems: Array<EeecCartItemInput>;
  shippingAddress: EeecShippingAddressInput;
};

export enum EeecOrderResultType {
  CompanyDoesNotAllowChargeCardOrders = 'COMPANY_DOES_NOT_ALLOW_CHARGE_CARD_ORDERS',
  Error = 'ERROR',
  InvalidData = 'INVALID_DATA',
  Success = 'SUCCESS',
  UserDisabled = 'USER_DISABLED',
  UserNotFound = 'USER_NOT_FOUND',
}

export type EeecPaymentDetailsInput = {
  accountHolder: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  iban: Scalars['String']['input'];
};

export type EeecPersonalDetailsInput = {
  address: EeecAddressInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export enum EeecQrCodeScanResponseResultType {
  EvseFoundAndServed = 'EVSE_FOUND_AND_SERVED',
  EvseNotFound = 'EVSE_NOT_FOUND',
  KnownInvalidString = 'KNOWN_INVALID_STRING',
  NoEvseFoundInUrl = 'NO_EVSE_FOUND_IN_URL',
  OperatorNotServed = 'OPERATOR_NOT_SERVED',
}

export enum EeecRemoveFavouriteResult {
  Error = 'ERROR',
  LocationNotInFavourites = 'LOCATION_NOT_IN_FAVOURITES',
  Success = 'SUCCESS',
}

export enum EeecRequiredAction {
  None = 'NONE',
  ProvideBusinessEmail = 'PROVIDE_BUSINESS_EMAIL',
  ProvideContractualDetails = 'PROVIDE_CONTRACTUAL_DETAILS',
  ProvideLeasingContractDetails = 'PROVIDE_LEASING_CONTRACT_DETAILS',
  RenewAccount = 'RENEW_ACCOUNT',
  SelectCarCustomerGroup = 'SELECT_CAR_CUSTOMER_GROUP',
  SelectUserGroup = 'SELECT_USER_GROUP',
  TriggerOnboardingFinalization = 'TRIGGER_ONBOARDING_FINALIZATION',
  VerifyBusinessEmail = 'VERIFY_BUSINESS_EMAIL',
  WaitForHrApproval = 'WAIT_FOR_HR_APPROVAL',
  WaitForOnboardingCompletion = 'WAIT_FOR_ONBOARDING_COMPLETION',
}

export enum EeecResendUserAccountRenewalNotificationResultType {
  Error = 'ERROR',
  RenewalNotRequired = 'RENEWAL_NOT_REQUIRED',
  Success = 'SUCCESS',
}

export enum EeecRestartOnboardingResponse {
  Failure = 'FAILURE',
  OperationNotAllowed = 'OPERATION_NOT_ALLOWED',
  Success = 'SUCCESS',
}

export type EeecSelectCarCustomerGroupRequestInput = {
  carCustomerGroupId: Scalars['UUID']['input'];
};

export enum EeecSessionStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN',
}

export type EeecShippingAddressInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryIso: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export enum EeecStartSessionResultType {
  Error = 'ERROR',
  EvseNotFound = 'EVSE_NOT_FOUND',
  EvseNotRemoteStartStopCapable = 'EVSE_NOT_REMOTE_START_STOP_CAPABLE',
  EvseUnavailable = 'EVSE_UNAVAILABLE',
  InvalidSubscription = 'INVALID_SUBSCRIPTION',
  Success = 'SUCCESS',
  UserDisabledOrNotFound = 'USER_DISABLED_OR_NOT_FOUND',
}

export enum EeecStepBackOnboardingResponse {
  Failure = 'FAILURE',
  OperationNotAllowed = 'OPERATION_NOT_ALLOWED',
  Success = 'SUCCESS',
}

export enum EeecStopSessionResultType {
  Error = 'ERROR',
  EvseUnavailable = 'EVSE_UNAVAILABLE',
  SessionNotFound = 'SESSION_NOT_FOUND',
  Success = 'SUCCESS',
  UnknownSession = 'UNKNOWN_SESSION',
  UserInvalidOrNotFound = 'USER_INVALID_OR_NOT_FOUND',
}

export enum EeecTariffPowerType {
  Ac = 'AC',
  Dc = 'DC',
}

export type EeecUpdateBusinessEmailRequestInput = {
  email: Scalars['String']['input'];
};

export type EeecUpdateContractualDetailsRequestInput = {
  marketingAuthorized: Scalars['Boolean']['input'];
  paymentDetails: EeecPaymentDetailsInput;
  personalDetails: EeecPersonalDetailsInput;
};

export type EeecUpdateEDriverRequestInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type EeecUpdateLeasingContractDetailsRequestInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  leasingContractDetails: EeecLeasingContractDetailsInput;
  marketingAuthorized: Scalars['Boolean']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export enum EeecUpdateResultType {
  Error = 'ERROR',
  InvalidData = 'INVALID_DATA',
  NotFound = 'NOT_FOUND',
  OperationNotAllowed = 'OPERATION_NOT_ALLOWED',
  Success = 'SUCCESS',
}

export type EeecUpdateUserGroupRequestInput = {
  userGroup: EeecUserGroup;
};

export enum EeecUpdateUserLocaleResponse {
  InvalidLocaleCode = 'INVALID_LOCALE_CODE',
  Success = 'SUCCESS',
  UserNotFound = 'USER_NOT_FOUND',
}

export enum EeecUserAccountRenewalResponse {
  AccountNotRenewable = 'ACCOUNT_NOT_RENEWABLE',
  Error = 'ERROR',
  InvalidVerificationCode = 'INVALID_VERIFICATION_CODE',
  Success = 'SUCCESS',
}

export enum EeecUserGroup {
  LeasingDriver = 'LEASING_DRIVER',
  PrivateEmployee = 'PRIVATE_EMPLOYEE',
}

export type EeecUserRequestInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  sendMagicLink: Scalars['Boolean']['input'];
};

export enum EeecVehicleCreationResponse {
  FailureAssignmentPeriodEndBeforeStart = 'FAILURE_ASSIGNMENT_PERIOD_END_BEFORE_START',
  FailureLicensePlateOccupiedWithinAssignmentPeriod = 'FAILURE_LICENSE_PLATE_OCCUPIED_WITHIN_ASSIGNMENT_PERIOD',
  FailureUserNotAuthorizedToAddVehicles = 'FAILURE_USER_NOT_AUTHORIZED_TO_ADD_VEHICLES',
  FailureUserNotFound = 'FAILURE_USER_NOT_FOUND',
  Success = 'SUCCESS',
}

export enum EeecVehicleUnassignmentResponse {
  FailureVehicleDoesNotBelongToUser = 'FAILURE_VEHICLE_DOES_NOT_BELONG_TO_USER',
  FailureVehicleNotFound = 'FAILURE_VEHICLE_NOT_FOUND',
  Success = 'SUCCESS',
}

export type ElectricityTariffInput = {
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  workPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum EmobilityContractStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Revoked = 'REVOKED',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
}

export enum EmobilityTariffType {
  BlockingDurationFast = 'BLOCKING_DURATION_FAST',
  BlockingDurationSlow = 'BLOCKING_DURATION_SLOW',
  BlockingFeeFast = 'BLOCKING_FEE_FAST',
  BlockingFeeSlow = 'BLOCKING_FEE_SLOW',
  Fast = 'FAST',
  Slow = 'SLOW',
}

export type EmobilityTariffTypeOperationFilterInput = {
  eq?: InputMaybe<EmobilityTariffType>;
  in?: InputMaybe<Array<EmobilityTariffType>>;
  neq?: InputMaybe<EmobilityTariffType>;
  nin?: InputMaybe<Array<EmobilityTariffType>>;
};

export enum EmobilityType {
  Advantage = 'ADVANTAGE',
  Error = 'ERROR',
  None = 'NONE',
  Standard = 'STANDARD',
}

export enum Energy {
  Electricity = 'ELECTRICITY',
  Gas = 'GAS',
  None = 'NONE',
}

export enum EnergyCostAidStatus {
  Calculated = 'CALCULATED',
  Notapplicable = 'NOTAPPLICABLE',
  Unknown = 'UNKNOWN',
}

export enum EnergyInput {
  Electricity = 'ELECTRICITY',
  Gas = 'GAS',
}

export type EnergyPriceCurvesInput = {
  end: Scalars['DateTime']['input'];
  powerCloudContractId: Scalars['Int']['input'];
  priceCurveAggregation: PriceCurveAggregation;
  start: Scalars['DateTime']['input'];
};

export type EnergySolutionsLeadAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
};

export type EnergySolutionsLeadInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  heatedArea?: InputMaybe<Scalars['Decimal']['input']>;
  heatingFuelType?: InputMaybe<HeatingFuelTypeInput>;
  houseType?: InputMaybe<HouseType>;
  houseYearOfConstruction?: InputMaybe<YearOfConstructionInput>;
  installationAddress: EnergySolutionsLeadAddressInput;
  interestInHeatpump?: InputMaybe<Scalars['Boolean']['input']>;
  interestInPv?: InputMaybe<Scalars['Boolean']['input']>;
  interestInStromWallet?: InputMaybe<Scalars['Boolean']['input']>;
  interestInWallBox?: InputMaybe<Scalars['Boolean']['input']>;
  isHouseOwner?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  legalText?: InputMaybe<Scalars['String']['input']>;
  marketingLegalConsentText?: InputMaybe<Scalars['String']['input']>;
  numberOfResidents?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['UUID']['input'];
  webCampaignId?: InputMaybe<Scalars['String']['input']>;
};

export enum EnergySystemHardwareType {
  Accessory = 'ACCESSORY',
  BatteryAndAccessory = 'BATTERY_AND_ACCESSORY',
  Cable = 'CABLE',
  EnergyManagement = 'ENERGY_MANAGEMENT',
  Heatpump = 'HEATPUMP',
  Inverter = 'INVERTER',
  Other = 'OTHER',
  SolarModule = 'SOLAR_MODULE',
  Wallbox = 'WALLBOX',
}

export enum EvseChargingLogic {
  MaxPower = 'MAX_POWER',
  Schedule = 'SCHEDULE',
}

export type EvseChargingLogicOperationFilterInput = {
  eq?: InputMaybe<EvseChargingLogic>;
  in?: InputMaybe<Array<EvseChargingLogic>>;
  neq?: InputMaybe<EvseChargingLogic>;
  nin?: InputMaybe<Array<EvseChargingLogic>>;
};

export enum EvseChargingMode {
  Changing = 'CHANGING',
  Managed = 'MANAGED',
  PlugAndCharge = 'PLUG_AND_CHARGE',
  Unknown = 'UNKNOWN',
}

export type EvseChargingModeOperationFilterInput = {
  eq?: InputMaybe<EvseChargingMode>;
  in?: InputMaybe<Array<EvseChargingMode>>;
  neq?: InputMaybe<EvseChargingMode>;
  nin?: InputMaybe<Array<EvseChargingMode>>;
};

export type ExperimentInput = {
  name: Scalars['String']['input'];
  variant: Scalars['String']['input'];
};

export type ExpertModeInput = {
  batterySize?: InputMaybe<Scalars['Decimal']['input']>;
  didUseExpertMode?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPanels?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportSmartMeterConsumptionMeasurementsInput = {
  year: Scalars['Int']['input'];
};

export type ExtendedDataGroupFilterInput = {
  and?: InputMaybe<Array<ExtendedDataGroupFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExtendedDataGroupFilterInput>>;
  technicalKey?: InputMaybe<StringOperationFilterInput>;
  values?: InputMaybe<ListFilterInputTypeOfExtendedDataValueFilterInput>;
};

export type ExtendedDataValueFilterInput = {
  and?: InputMaybe<Array<ExtendedDataValueFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExtendedDataValueFilterInput>>;
  technicalKey?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export enum ExtensionTimeType {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
}

export type ExternalIdentifiersFilterInput = {
  and?: InputMaybe<Array<ExternalIdentifiersFilterInput>>;
  easyArchiveGuid?: InputMaybe<ComparableNullableOfGuidOperationFilterInput>;
  or?: InputMaybe<Array<ExternalIdentifiersFilterInput>>;
  powerCloudId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ExternalIdentifiersSortInput = {
  easyArchiveGuid?: InputMaybe<SortEnumType>;
  powerCloudId?: InputMaybe<SortEnumType>;
};

export enum FixedPriceType {
  Fixedpricetypeenergy = 'FIXEDPRICETYPEENERGY',
  Fixedpricetypefix = 'FIXEDPRICETYPEFIX',
  Fixedpricetypegoodwill = 'FIXEDPRICETYPEGOODWILL',
  Guaranteedate = 'GUARANTEEDATE',
  Guaranteedatefix = 'GUARANTEEDATEFIX',
  Guaranteedatefullpriceexcludingvat = 'GUARANTEEDATEFULLPRICEEXCLUDINGVAT',
  Guaranteedatefullpriceincludingvatandnewtaxes = 'GUARANTEEDATEFULLPRICEINCLUDINGVATANDNEWTAXES',
  Guaranteedategoodwill = 'GUARANTEEDATEGOODWILL',
  Guaranteemonths = 'GUARANTEEMONTHS',
  Guaranteemonthsfix = 'GUARANTEEMONTHSFIX',
  Guaranteemonthsfullpriceexcludingvat = 'GUARANTEEMONTHSFULLPRICEEXCLUDINGVAT',
  Guaranteemonthsfullpriceincludingvatandnewtaxes = 'GUARANTEEMONTHSFULLPRICEINCLUDINGVATANDNEWTAXES',
  Guaranteemonthsgoodwill = 'GUARANTEEMONTHSGOODWILL',
  None = 'NONE',
  Unknown = 'UNKNOWN',
}

export type FixedPriceTypeOperationFilterInput = {
  eq?: InputMaybe<FixedPriceType>;
  in?: InputMaybe<Array<FixedPriceType>>;
  neq?: InputMaybe<FixedPriceType>;
  nin?: InputMaybe<Array<FixedPriceType>>;
};

export type FlexBonusInput = {
  amount: Scalars['Decimal']['input'];
  considerValidFromAndValidUntil: Scalars['Boolean']['input'];
  disbursementType: DisbursementType;
  durationFromMonths?: InputMaybe<Scalars['Int']['input']>;
  durationInMonths?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentAfterMonths?: InputMaybe<Scalars['Int']['input']>;
  usageFrom?: InputMaybe<Scalars['DateTime']['input']>;
  usageUntil?: InputMaybe<Scalars['DateTime']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The format describes the physical (electrical and mechanical) conditions a car must met to start charging. */
export type FormatFilterInput = {
  and?: InputMaybe<Array<FormatFilterInput>>;
  /** The category for quick filtering. Maps to limits of the power field. */
  category?: InputMaybe<CategoryOperationFilterInput>;
  /** The maximum (not guaranteed) power in kW */
  maxPower?: InputMaybe<ComparableDecimalOperationFilterInput>;
  or?: InputMaybe<Array<FormatFilterInput>>;
  /** The standard (plug type) that a customer needs to charge. */
  plugType?: InputMaybe<StandardOperationFilterInput>;
  /** Information about the side of the cable (true = station provides cable, false = customer must provide a cable) */
  tethered?: InputMaybe<BooleanOperationFilterInput>;
};

export type FutureContractPricesInput = {
  contractPrices?: InputMaybe<Array<InputMaybe<ContractPriceInput>>>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productVersion: Scalars['Int']['input'];
};

export type FutureDepositFilterInput = {
  and?: InputMaybe<Array<FutureDepositFilterInput>>;
  dueDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  grossAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  or?: InputMaybe<Array<FutureDepositFilterInput>>;
};

export type GridFeeReductionsFilterInput = {
  and?: InputMaybe<Array<GridFeeReductionsFilterInput>>;
  enwg14AModule1NetworkUsageFeeReductionEuroPerYear?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  enwg14AModule1NetworkUsageFeeReductionEuroPerYearNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  enwg14AModule2EstimatedNetworkUsageFeeReductionEuroPerYear?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  enwg14AModule2EstimatedNetworkUsageFeeReductionEuroPerYearNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  enwg14AModule2ReducedWorkingPriceCtPerKwh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  enwg14AModule2ReducedWorkingPriceCtPerKwhNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<GridFeeReductionsFilterInput>>;
};

export type GridFeeReductionsSortInput = {
  enwg14AModule1NetworkUsageFeeReductionEuroPerYear?: InputMaybe<SortEnumType>;
  enwg14AModule1NetworkUsageFeeReductionEuroPerYearNet?: InputMaybe<SortEnumType>;
  enwg14AModule2EstimatedNetworkUsageFeeReductionEuroPerYear?: InputMaybe<SortEnumType>;
  enwg14AModule2EstimatedNetworkUsageFeeReductionEuroPerYearNet?: InputMaybe<SortEnumType>;
  enwg14AModule2ReducedWorkingPriceCtPerKwh?: InputMaybe<SortEnumType>;
  enwg14AModule2ReducedWorkingPriceCtPerKwhNet?: InputMaybe<SortEnumType>;
};

export enum HardwareTypeEnum {
  Accessory = 'ACCESSORY',
  BatteryAndAccessory = 'BATTERY_AND_ACCESSORY',
  Cable = 'CABLE',
  EnergyManagement = 'ENERGY_MANAGEMENT',
  HeatPump = 'HEAT_PUMP',
  Inverter = 'INVERTER',
  Other = 'OTHER',
  SolarModule = 'SOLAR_MODULE',
  Undefined = 'UNDEFINED',
  Wallbox = 'WALLBOX',
}

export enum HeatEmissionTypeInput {
  Other = 'OTHER',
  Radiator = 'RADIATOR',
  RadiatorAndUnderfloorHeating = 'RADIATOR_AND_UNDERFLOOR_HEATING',
  UnderfloorHeating = 'UNDERFLOOR_HEATING',
}

export enum HeatingFuelTypeInput {
  Gas = 'GAS',
  Heatpump = 'HEATPUMP',
  Oil = 'OIL',
  Other = 'OTHER',
  Pellet = 'PELLET',
}

export enum HighConsuptionTime {
  AllDay = 'ALL_DAY',
  MorningAndAfternoon = 'MORNING_AND_AFTERNOON',
}

export enum HouseType {
  ApartmentBuilding = 'APARTMENT_BUILDING',
  CommercialBuilding = 'COMMERCIAL_BUILDING',
  Detached = 'DETACHED',
  Terraced = 'TERRACED',
  TwoFamily = 'TWO_FAMILY',
}

export type HtbFormatFilterInput = {
  and?: InputMaybe<Array<HtbFormatFilterInput>>;
  chargePointType?: InputMaybe<StringOperationFilterInput>;
  chargingFacilityType?: InputMaybe<StringOperationFilterInput>;
  maxPower?: InputMaybe<ComparableNullableOfSingleOperationFilterInput>;
  or?: InputMaybe<Array<HtbFormatFilterInput>>;
  plugType?: InputMaybe<StringOperationFilterInput>;
  standard?: InputMaybe<StringOperationFilterInput>;
};

export type IbanValidationFilterInput = {
  and?: InputMaybe<Array<IbanValidationFilterInput>>;
  bankName?: InputMaybe<StringOperationFilterInput>;
  iban?: InputMaybe<StringOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<IbanValidationFilterInput>>;
};

export type IbanValidationSortInput = {
  bankName?: InputMaybe<SortEnumType>;
  iban?: InputMaybe<SortEnumType>;
  isValid?: InputMaybe<SortEnumType>;
};

export type InitializeEvseCompatibilityCheckInput = {
  callbackUrlFailure: Scalars['String']['input'];
  callbackUrlSuccess: Scalars['String']['input'];
};

export type InitializeEvseOnboardingInput = {
  callbackUrlFailure: Scalars['String']['input'];
  callbackUrlSuccess: Scalars['String']['input'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceFilterInput = {
  and?: InputMaybe<Array<InvoiceFilterInput>>;
  archiveId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  creditAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  externalIdentifiers?: InputMaybe<ExternalIdentifiersFilterInput>;
  hasBeenRead?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  invoiceAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  invoiceType?: InputMaybe<InvoiceTypeOperationFilterInput>;
  invoicingDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  invoicingPeriodEnd?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  invoicingPeriodStart?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  isCancelled?: InputMaybe<BooleanOperationFilterInput>;
  isEasyArchive?: InputMaybe<BooleanOperationFilterInput>;
  isPaid?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<InvoiceFilterInput>>;
  payableAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  paymentMethod?: InputMaybe<PaymentMethodOperationFilterInput>;
  subsequentPaymentAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  usage?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export type InvoiceSortInput = {
  archiveId?: InputMaybe<SortEnumType>;
  creditAmount?: InputMaybe<SortEnumType>;
  externalIdentifiers?: InputMaybe<ExternalIdentifiersSortInput>;
  hasBeenRead?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invoiceAmount?: InputMaybe<SortEnumType>;
  invoiceNumber?: InputMaybe<SortEnumType>;
  invoiceType?: InputMaybe<SortEnumType>;
  invoicingDate?: InputMaybe<SortEnumType>;
  invoicingPeriodEnd?: InputMaybe<SortEnumType>;
  invoicingPeriodStart?: InputMaybe<SortEnumType>;
  isCancelled?: InputMaybe<SortEnumType>;
  isEasyArchive?: InputMaybe<SortEnumType>;
  isPaid?: InputMaybe<SortEnumType>;
  payableAt?: InputMaybe<SortEnumType>;
  paymentMethod?: InputMaybe<SortEnumType>;
  subsequentPaymentAmount?: InputMaybe<SortEnumType>;
  usage?: InputMaybe<SortEnumType>;
};

export enum InvoiceType {
  Inbetween = 'INBETWEEN',
  Last = 'LAST',
  Turnus = 'TURNUS',
  Unknown = 'UNKNOWN',
}

export type InvoiceTypeOperationFilterInput = {
  eq?: InputMaybe<InvoiceType>;
  in?: InputMaybe<Array<InvoiceType>>;
  neq?: InputMaybe<InvoiceType>;
  nin?: InputMaybe<Array<InvoiceType>>;
};

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LatestEaasChargingTransactionFilterInput = {
  and?: InputMaybe<Array<LatestEaasChargingTransactionFilterInput>>;
  averageChargePower?: InputMaybe<ComparableDoubleOperationFilterInput>;
  averageChargePowerWatt?: InputMaybe<ComparableDoubleOperationFilterInput>;
  averageConsumed?: InputMaybe<ComparableDoubleOperationFilterInput>;
  averageConsumedWh?: InputMaybe<ComparableDoubleOperationFilterInput>;
  chargingDurationInSeconds?: InputMaybe<ComparableInt32OperationFilterInput>;
  endedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableGuidOperationFilterInput>;
  lastUpdatedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LatestEaasChargingTransactionFilterInput>>;
  startedAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  status?: InputMaybe<ChargingTransactionStatusOperationFilterInput>;
};

export enum LbEvseStatus {
  Available = 'AVAILABLE',
  Charging = 'CHARGING',
  Completed = 'COMPLETED',
  Connected = 'CONNECTED',
  Error = 'ERROR',
  Fake = 'FAKE',
  Starting = 'STARTING',
  Stopping = 'STOPPING',
  Suspended = 'SUSPENDED',
  Unavailable = 'UNAVAILABLE',
}

export type LbEvseStatusOperationFilterInput = {
  eq?: InputMaybe<LbEvseStatus>;
  in?: InputMaybe<Array<LbEvseStatus>>;
  neq?: InputMaybe<LbEvseStatus>;
  nin?: InputMaybe<Array<LbEvseStatus>>;
};

export type ListCapabilitiesOperationFilterInput = {
  all?: InputMaybe<CapabilitiesOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CapabilitiesOperationFilterInput>;
  some?: InputMaybe<CapabilitiesOperationFilterInput>;
};

export type ListComparableDoubleOperationFilterInput = {
  all?: InputMaybe<ComparableDoubleOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ComparableDoubleOperationFilterInput>;
  some?: InputMaybe<ComparableDoubleOperationFilterInput>;
};

export type ListFilterInputTypeOfBonusFilterInput = {
  all?: InputMaybe<BonusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BonusFilterInput>;
  some?: InputMaybe<BonusFilterInput>;
};

export type ListFilterInputTypeOfCommunicationFilterInput = {
  all?: InputMaybe<CommunicationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CommunicationFilterInput>;
  some?: InputMaybe<CommunicationFilterInput>;
};

export type ListFilterInputTypeOfConnectorFilterInput = {
  all?: InputMaybe<ConnectorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConnectorFilterInput>;
  some?: InputMaybe<ConnectorFilterInput>;
};

export type ListFilterInputTypeOfContractStatusHistoryFilterInput = {
  all?: InputMaybe<ContractStatusHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContractStatusHistoryFilterInput>;
  some?: InputMaybe<ContractStatusHistoryFilterInput>;
};

export type ListFilterInputTypeOfDepositFilterInput = {
  all?: InputMaybe<DepositFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DepositFilterInput>;
  some?: InputMaybe<DepositFilterInput>;
};

export type ListFilterInputTypeOfExtendedDataGroupFilterInput = {
  all?: InputMaybe<ExtendedDataGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ExtendedDataGroupFilterInput>;
  some?: InputMaybe<ExtendedDataGroupFilterInput>;
};

export type ListFilterInputTypeOfExtendedDataValueFilterInput = {
  all?: InputMaybe<ExtendedDataValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ExtendedDataValueFilterInput>;
  some?: InputMaybe<ExtendedDataValueFilterInput>;
};

export type ListFilterInputTypeOfFutureDepositFilterInput = {
  all?: InputMaybe<FutureDepositFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FutureDepositFilterInput>;
  some?: InputMaybe<FutureDepositFilterInput>;
};

export type ListFilterInputTypeOfInvoiceFilterInput = {
  all?: InputMaybe<InvoiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvoiceFilterInput>;
  some?: InputMaybe<InvoiceFilterInput>;
};

export type ListFilterInputTypeOfOpeningTimePeriodFilterInput = {
  all?: InputMaybe<OpeningTimePeriodFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OpeningTimePeriodFilterInput>;
  some?: InputMaybe<OpeningTimePeriodFilterInput>;
};

export type ListFilterInputTypeOfProductFilterInput = {
  all?: InputMaybe<ProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductFilterInput>;
  some?: InputMaybe<ProductFilterInput>;
};

export type ListFilterInputTypeOfReadingFilterInput = {
  all?: InputMaybe<ReadingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReadingFilterInput>;
  some?: InputMaybe<ReadingFilterInput>;
};

export type ListFilterInputTypeOfRegisterFilterInput = {
  all?: InputMaybe<RegisterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RegisterFilterInput>;
  some?: InputMaybe<RegisterFilterInput>;
};

export type ListFilterInputTypeOfStationFilterInput = {
  all?: InputMaybe<StationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StationFilterInput>;
  some?: InputMaybe<StationFilterInput>;
};

export type ListFilterInputTypeOfStreetFilterInput = {
  all?: InputMaybe<StreetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StreetFilterInput>;
  some?: InputMaybe<StreetFilterInput>;
};

export type ListFilterInputTypeOfTariffFilterInput = {
  all?: InputMaybe<TariffFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TariffFilterInput>;
  some?: InputMaybe<TariffFilterInput>;
};

export type ListFilterInputTypeOfTariffInformationFilterInput = {
  all?: InputMaybe<TariffInformationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TariffInformationFilterInput>;
  some?: InputMaybe<TariffInformationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LocationBoxInput = {
  max: LocationPointInput;
  min: LocationPointInput;
};

export type LocationClusterFilterInput = {
  and?: InputMaybe<Array<LocationClusterFilterInput>>;
  available?: InputMaybe<BooleanOperationFilterInput>;
  latitude?: InputMaybe<ComparableDoubleOperationFilterInput>;
  longitude?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<LocationClusterFilterInput>>;
  total?: InputMaybe<ComparableInt32OperationFilterInput>;
  unavailable?: InputMaybe<BooleanOperationFilterInput>;
  unknown?: InputMaybe<BooleanOperationFilterInput>;
};

export type LocationClusterFiltersInput = {
  availableOnly: Scalars['Boolean']['input'];
  categories: Array<Category>;
  freeOnly: Scalars['Boolean']['input'];
  standards: Array<Standard>;
  twentyFourSevenOnly: Scalars['Boolean']['input'];
};

export type LocationClusterInput = {
  box: LocationBoxInput;
  clusterFilter?: InputMaybe<LocationClusterFiltersInput>;
};

export type LocationClusterSortInput = {
  available?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  unavailable?: InputMaybe<SortEnumType>;
  unknown?: InputMaybe<SortEnumType>;
};

export type LocationDetailsCompactInput = {
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  postalCode: Scalars['String']['input'];
};

export type LocationPointInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** A location is a physical point and holds one or more stations with one or more plugs. */
export type LocationSearchModelFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<LocationSearchModelFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  /** New field for the best text representing the charge point for the UI */
  displayName?: InputMaybe<StringOperationFilterInput>;
  hasBlockingFee?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isChargingDisabled?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<PointModelFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  openingTimes?: InputMaybe<OpeningTimesFilterInput>;
  operatorCode?: InputMaybe<StringOperationFilterInput>;
  operatorEmail?: InputMaybe<StringOperationFilterInput>;
  operatorName?: InputMaybe<StringOperationFilterInput>;
  operatorPhone?: InputMaybe<StringOperationFilterInput>;
  operatorUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationSearchModelFilterInput>>;
  stations?: InputMaybe<ListFilterInputTypeOfStationFilterInput>;
  tariffInformation?: InputMaybe<ListFilterInputTypeOfTariffInformationFilterInput>;
  zip?: InputMaybe<StringOperationFilterInput>;
};

/** A location is a physical point and holds one or more stations with one or more plugs. */
export type LocationSearchModelSortInput = {
  address?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  /** New field for the best text representing the charge point for the UI */
  displayName?: InputMaybe<SortEnumType>;
  hasBlockingFee?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isChargingDisabled?: InputMaybe<SortEnumType>;
  location?: InputMaybe<PointModelSortInput>;
  name?: InputMaybe<SortEnumType>;
  openingTimes?: InputMaybe<OpeningTimesSortInput>;
  operatorCode?: InputMaybe<SortEnumType>;
  operatorEmail?: InputMaybe<SortEnumType>;
  operatorName?: InputMaybe<SortEnumType>;
  operatorPhone?: InputMaybe<SortEnumType>;
  operatorUrl?: InputMaybe<SortEnumType>;
  zip?: InputMaybe<SortEnumType>;
};

export type LocationSpecificEnergyPriceCurveInput = {
  householdConsumption?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};

export type MarketingDataInput = {
  allowAdvertisementOverMail?: InputMaybe<Scalars['Boolean']['input']>;
  allowAdvertisementOverPhone?: InputMaybe<Scalars['Boolean']['input']>;
  allowAdvertisementOverPost?: InputMaybe<Scalars['Boolean']['input']>;
  optin: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingLeadDtoInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  legalText: Scalars['String']['input'];
  requestId: Scalars['UUID']['input'];
  target: Scalars['String']['input'];
  webCampaignId?: InputMaybe<Scalars['String']['input']>;
};

export enum MessageType {
  All = 'ALL',
  Communication = 'COMMUNICATION',
  Invoice = 'INVOICE',
}

export enum MinimumRuntimeType {
  Days = 'DAYS',
  Months = 'MONTHS',
}

export type NcsLeadAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type NcsParkLeadInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseType?: InputMaybe<HouseType>;
  installationAddress: NcsLeadAddressInput;
  isHouseOwner: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalText: Scalars['String']['input'];
  marketingLegalConsentText?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['UUID']['input'];
  roofAreaSize?: InputMaybe<Scalars['Decimal']['input']>;
  roofMaterial?: InputMaybe<RoofMaterial>;
};

export type NonCommodityAddOnInput = {
  amount: Scalars['Int']['input'];
  productCode?: InputMaybe<Scalars['String']['input']>;
};

export type NonCommodityOrderExtendedInput = {
  activateOrder?: InputMaybe<Scalars['Boolean']['input']>;
  addOns?: InputMaybe<Array<InputMaybe<NonCommodityAddOnInput>>>;
  amount: Scalars['Int']['input'];
  business?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This property is deprecated, because it exists in the contact-class */
  company?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerSpecification: CustomerSpecification;
  externalId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  signatureDate: Scalars['DateTime']['input'];
};

export type NonCommodityOrderInput = {
  activateOrder?: InputMaybe<Scalars['Boolean']['input']>;
  addOns?: InputMaybe<Array<InputMaybe<NonCommodityAddOnInput>>>;
  amount: Scalars['Int']['input'];
  business?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This property is deprecated, because it exists in the contact-class */
  company?: InputMaybe<Scalars['String']['input']>;
  customerSpecification: CustomerSpecification;
  price?: InputMaybe<Scalars['Float']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  signatureDate: Scalars['DateTime']['input'];
};

export type NonCommodityProductFilterInput = {
  agb?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<NonCommodityProductFilterInput>>;
  extendedDataGroups?: InputMaybe<ListFilterInputTypeOfExtendedDataGroupFilterInput>;
  or?: InputMaybe<Array<NonCommodityProductFilterInput>>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  productName?: InputMaybe<StringOperationFilterInput>;
};

export type NullableOfCancellationReasonOperationFilterInput = {
  eq?: InputMaybe<CancellationReason>;
  in?: InputMaybe<Array<InputMaybe<CancellationReason>>>;
  neq?: InputMaybe<CancellationReason>;
  nin?: InputMaybe<Array<InputMaybe<CancellationReason>>>;
};

export type NullableOfContractStatusOperationFilterInput = {
  eq?: InputMaybe<ContractStatus>;
  in?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  neq?: InputMaybe<ContractStatus>;
  nin?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
};

export type NullableOfCustomerSpecificationsOperationFilterInput = {
  eq?: InputMaybe<CustomerSpecifications>;
  in?: InputMaybe<Array<InputMaybe<CustomerSpecifications>>>;
  neq?: InputMaybe<CustomerSpecifications>;
  nin?: InputMaybe<Array<InputMaybe<CustomerSpecifications>>>;
};

export type NullableOfReadingQualifierOperationFilterInput = {
  eq?: InputMaybe<ReadingQualifier>;
  in?: InputMaybe<Array<InputMaybe<ReadingQualifier>>>;
  neq?: InputMaybe<ReadingQualifier>;
  nin?: InputMaybe<Array<InputMaybe<ReadingQualifier>>>;
};

export type NullableOfRegisterTypeOperationFilterInput = {
  eq?: InputMaybe<RegisterType>;
  in?: InputMaybe<Array<InputMaybe<RegisterType>>>;
  neq?: InputMaybe<RegisterType>;
  nin?: InputMaybe<Array<InputMaybe<RegisterType>>>;
};

export type NullableOfScheduleActivationStatusOperationFilterInput = {
  eq?: InputMaybe<ScheduleActivationStatus>;
  in?: InputMaybe<Array<InputMaybe<ScheduleActivationStatus>>>;
  neq?: InputMaybe<ScheduleActivationStatus>;
  nin?: InputMaybe<Array<InputMaybe<ScheduleActivationStatus>>>;
};

export type OpeningTimePeriodFilterInput = {
  and?: InputMaybe<Array<OpeningTimePeriodFilterInput>>;
  begin?: InputMaybe<StringOperationFilterInput>;
  end?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OpeningTimePeriodFilterInput>>;
  weekday?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Opening times and 24/7 hint. */
export type OpeningTimesFilterInput = {
  and?: InputMaybe<Array<OpeningTimesFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  exceptions?: InputMaybe<ListFilterInputTypeOfOpeningTimePeriodFilterInput>;
  or?: InputMaybe<Array<OpeningTimesFilterInput>>;
  regular?: InputMaybe<ListFilterInputTypeOfOpeningTimePeriodFilterInput>;
  twentyFourSeven?: InputMaybe<BooleanOperationFilterInput>;
};

/** Opening times and 24/7 hint. */
export type OpeningTimesSortInput = {
  description?: InputMaybe<SortEnumType>;
  twentyFourSeven?: InputMaybe<SortEnumType>;
};

export type OrderExtendedInput = {
  business?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIdentifier?: InputMaybe<Scalars['String']['input']>;
  cancellationPeriod?: InputMaybe<Scalars['Float']['input']>;
  cancellationPeriodType?: InputMaybe<CancellationPeriodType>;
  /** @deprecated This property is deprecated, because it exists in the contact-class */
  company?: InputMaybe<Scalars['String']['input']>;
  counterNumber?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated This property is deprecated, because it does something different than expected. Most likely you want to use customerId to match the order to a customer account. */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  customerSpecification: CustomerSpecification;
  deposit?: InputMaybe<Scalars['Decimal']['input']>;
  desiredDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  energy: EnergyInput;
  extensionTime?: InputMaybe<Scalars['Float']['input']>;
  extensionTimeType?: InputMaybe<ExtensionTimeType>;
  externalContractId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated please use collection property 'FlexBonuses' instead */
  flexBonus?: InputMaybe<FlexBonusInput>;
  flexBonuses?: InputMaybe<Array<InputMaybe<FlexBonusInput>>>;
  isRlm: Scalars['Boolean']['input'];
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  minimumRuntime?: InputMaybe<Scalars['Float']['input']>;
  minimumRuntimeType?: InputMaybe<MinimumRuntimeType>;
  previousProviderCodeNumber?: InputMaybe<Scalars['String']['input']>;
  productBasePrice?: InputMaybe<Scalars['Float']['input']>;
  productBonus?: InputMaybe<Scalars['Float']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productInstantBonus?: InputMaybe<Scalars['Float']['input']>;
  productPrices?: InputMaybe<PricesInput>;
  productWorkingPrice?: InputMaybe<Scalars['Float']['input']>;
  relocationDate?: InputMaybe<Scalars['DateTime']['input']>;
  signatureDate: Scalars['DateTime']['input'];
  tariffOfferToken?: InputMaybe<Scalars['String']['input']>;
  terminationDate?: InputMaybe<Scalars['DateTime']['input']>;
  usage?: InputMaybe<UsageInput>;
  waitForConfirmationUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderFilterInput = {
  address?: InputMaybe<AddressFilterInput>;
  and?: InputMaybe<Array<OrderFilterInput>>;
  bankAccount?: InputMaybe<BankAccountFilterInput>;
  basePriceGross?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  basePriceNet?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  billingAddress?: InputMaybe<AddressFilterInput>;
  billingEmail?: InputMaybe<StringOperationFilterInput>;
  campaign?: InputMaybe<StringOperationFilterInput>;
  confirmedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  contractPeriod?: InputMaybe<PeriodFilterInput>;
  contractRenewalPeriod?: InputMaybe<PeriodFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  meterNumber?: InputMaybe<StringOperationFilterInput>;
  monthlyBasePriceGross?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  or?: InputMaybe<Array<OrderFilterInput>>;
  orderedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  priceGuarantee?: InputMaybe<PeriodFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  salesPartnerCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<OrderStatusOperationFilterInput>;
  uniqueSalesPartnerCode?: InputMaybe<StringOperationFilterInput>;
  usage?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  waitForConfirmationUntil?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  workingPriceGross?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  workingPriceNet?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
};

export type OrderInput = {
  business?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIdentifier?: InputMaybe<Scalars['String']['input']>;
  cancellationPeriod?: InputMaybe<Scalars['Float']['input']>;
  cancellationPeriodType?: InputMaybe<CancellationPeriodType>;
  /** @deprecated This property is deprecated, because it exists in the contact-class */
  company?: InputMaybe<Scalars['String']['input']>;
  counterNumber?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated This property is deprecated, because it does something different than expected. Most likely you want to use customerId to match the order to a customer account. */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  customerSpecification: CustomerSpecification;
  deposit?: InputMaybe<Scalars['Decimal']['input']>;
  desiredDate?: InputMaybe<Scalars['DateTime']['input']>;
  energy: EnergyInput;
  extensionTime?: InputMaybe<Scalars['Float']['input']>;
  extensionTimeType?: InputMaybe<ExtensionTimeType>;
  futureContractPrices?: InputMaybe<FutureContractPricesInput>;
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  minimumRuntime?: InputMaybe<Scalars['Float']['input']>;
  minimumRuntimeType?: InputMaybe<MinimumRuntimeType>;
  previousProviderCodeNumber?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  relocationDate?: InputMaybe<Scalars['DateTime']['input']>;
  signatureDate: Scalars['DateTime']['input'];
  tariffOfferToken?: InputMaybe<Scalars['String']['input']>;
  terminationDate?: InputMaybe<Scalars['DateTime']['input']>;
  usage: Scalars['Int']['input'];
  usageNt?: InputMaybe<Scalars['Int']['input']>;
  waitForConfirmationUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderSortInput = {
  address?: InputMaybe<AddressSortInput>;
  bankAccount?: InputMaybe<BankAccountSortInput>;
  basePriceGross?: InputMaybe<SortEnumType>;
  basePriceNet?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressSortInput>;
  billingEmail?: InputMaybe<SortEnumType>;
  campaign?: InputMaybe<SortEnumType>;
  confirmedAt?: InputMaybe<SortEnumType>;
  contractPeriod?: InputMaybe<PeriodSortInput>;
  contractRenewalPeriod?: InputMaybe<PeriodSortInput>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  meterNumber?: InputMaybe<SortEnumType>;
  monthlyBasePriceGross?: InputMaybe<SortEnumType>;
  orderedAt?: InputMaybe<SortEnumType>;
  priceGuarantee?: InputMaybe<PeriodSortInput>;
  product?: InputMaybe<ProductSortInput>;
  salesPartnerCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  uniqueSalesPartnerCode?: InputMaybe<SortEnumType>;
  usage?: InputMaybe<SortEnumType>;
  waitForConfirmationUntil?: InputMaybe<SortEnumType>;
  workingPriceGross?: InputMaybe<SortEnumType>;
  workingPriceNet?: InputMaybe<SortEnumType>;
};

export enum OrderStatus {
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Check = 'CHECK',
  Confirmed = 'CONFIRMED',
  Done = 'DONE',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING',
}

export type OrderStatusOperationFilterInput = {
  eq?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  neq?: InputMaybe<OrderStatus>;
  nin?: InputMaybe<Array<OrderStatus>>;
};

export enum Origins {
  Admin = 'ADMIN',
  Anonymize = 'ANONYMIZE',
  Backgroundservices = 'BACKGROUNDSERVICES',
  Customerservice = 'CUSTOMERSERVICE',
  Monitoring = 'MONITORING',
  Others = 'OTHERS',
  Unknown = 'UNKNOWN',
  Webservicegateway = 'WEBSERVICEGATEWAY',
}

export type OriginsOperationFilterInput = {
  eq?: InputMaybe<Origins>;
  in?: InputMaybe<Array<Origins>>;
  neq?: InputMaybe<Origins>;
  nin?: InputMaybe<Array<Origins>>;
};

export type ParagraphFilterInput = {
  and?: InputMaybe<Array<ParagraphFilterInput>>;
  body?: InputMaybe<StringOperationFilterInput>;
  bodyMd?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ParagraphFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type ParagraphSortInput = {
  body?: InputMaybe<SortEnumType>;
  bodyMd?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export enum PaymentMethod {
  Directdebit = 'DIRECTDEBIT',
  Sepamandat = 'SEPAMANDAT',
  Unknown = 'UNKNOWN',
}

export type PaymentMethodOperationFilterInput = {
  eq?: InputMaybe<PaymentMethod>;
  in?: InputMaybe<Array<PaymentMethod>>;
  neq?: InputMaybe<PaymentMethod>;
  nin?: InputMaybe<Array<PaymentMethod>>;
};

export type PeriodFilterInput = {
  and?: InputMaybe<Array<PeriodFilterInput>>;
  or?: InputMaybe<Array<PeriodFilterInput>>;
  unit?: InputMaybe<PeriodUnitOperationFilterInput>;
  value?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type PeriodSortInput = {
  unit?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export enum PeriodUnit {
  Days = 'DAYS',
  Months = 'MONTHS',
  Unknown = 'UNKNOWN',
  Weeks = 'WEEKS',
  Years = 'YEARS',
}

export type PeriodUnitOperationFilterInput = {
  eq?: InputMaybe<PeriodUnit>;
  in?: InputMaybe<Array<PeriodUnit>>;
  neq?: InputMaybe<PeriodUnit>;
  nin?: InputMaybe<Array<PeriodUnit>>;
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Unknown = 'UNKNOWN',
}

export type PointModelFilterInput = {
  and?: InputMaybe<Array<PointModelFilterInput>>;
  coordinates?: InputMaybe<ListComparableDoubleOperationFilterInput>;
  latitude?: InputMaybe<ComparableDoubleOperationFilterInput>;
  longitude?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<PointModelFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type PointModelSortInput = {
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum PowerCloudContractStatusPayload {
  Blocked = 'BLOCKED',
  Canceled = 'CANCELED',
  ChangeProcessNb = 'CHANGE_PROCESS_NB',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  InDelivery = 'IN_DELIVERY',
  None = 'NONE',
  Open = 'OPEN',
  Terminated = 'TERMINATED',
  TerminationLfa = 'TERMINATION_LFA',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
}

export enum PowerCloudContractTypePayload {
  Energy = 'ENERGY',
  FeedIn = 'FEED_IN',
  Hardware = 'HARDWARE',
}

export enum PowerCloudGridFeeModule {
  Module1 = 'MODULE1',
  Module2 = 'MODULE2',
  Module3 = 'MODULE3',
}

export type PowerConsumptionInput = {
  heatpump?: InputMaybe<Scalars['Int']['input']>;
  household: Scalars['Int']['input'];
  wallbox?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceCapDataFilterInput = {
  and?: InputMaybe<Array<PriceCapDataFilterInput>>;
  description?: InputMaybe<ParagraphFilterInput>;
  monthlyPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  monthlyPriceWithBonus?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<PriceCapDataFilterInput>>;
  status?: InputMaybe<PriceCapStatusOperationFilterInput>;
  totalPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalPriceWithBonus?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalWorkPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  workingPriceWeighed?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type PriceCapDataSortInput = {
  description?: InputMaybe<ParagraphSortInput>;
  monthlyPrice?: InputMaybe<SortEnumType>;
  monthlyPriceWithBonus?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  totalPrice?: InputMaybe<SortEnumType>;
  totalPriceWithBonus?: InputMaybe<SortEnumType>;
  totalWorkPrice?: InputMaybe<SortEnumType>;
  workingPriceWeighed?: InputMaybe<SortEnumType>;
};

export enum PriceCapStatus {
  HighUsage = 'HIGH_USAGE',
  LowWorkingPrice = 'LOW_WORKING_PRICE',
  None = 'NONE',
  PriceCap = 'PRICE_CAP',
}

export type PriceCapStatusOperationFilterInput = {
  eq?: InputMaybe<PriceCapStatus>;
  in?: InputMaybe<Array<PriceCapStatus>>;
  neq?: InputMaybe<PriceCapStatus>;
  nin?: InputMaybe<Array<PriceCapStatus>>;
};

export enum PriceCurveAggregation {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR',
}

export enum PriceGuarantees {
  Energy = 'ENERGY',
  Fix = 'FIX',
  GoodWill = 'GOOD_WILL',
  Netto = 'NETTO',
  NettoNetto = 'NETTO_NETTO',
  None = 'NONE',
}

export type PriceGuaranteesOperationFilterInput = {
  eq?: InputMaybe<PriceGuarantees>;
  in?: InputMaybe<Array<PriceGuarantees>>;
  neq?: InputMaybe<PriceGuarantees>;
  nin?: InputMaybe<Array<PriceGuarantees>>;
};

export type PriceInput = {
  priceBrutto: Scalars['Float']['input'];
  priceTaxRate: Scalars['Float']['input'];
  usageFrom: Scalars['Int']['input'];
  usageUntil: Scalars['Int']['input'];
};

export type PriceRecordBaseInput = {
  any?: InputMaybe<Array<InputMaybe<PriceInput>>>;
};

export type PriceRecordInput = {
  any?: InputMaybe<Array<InputMaybe<PriceInput>>>;
  ht?: InputMaybe<Array<InputMaybe<PriceInput>>>;
  nt?: InputMaybe<Array<InputMaybe<PriceInput>>>;
};

export enum PriceType {
  Multi = 'MULTI',
  None = 'NONE',
  Single = 'SINGLE',
  Unknown = 'UNKNOWN',
}

export type PriceTypeOperationFilterInput = {
  eq?: InputMaybe<PriceType>;
  in?: InputMaybe<Array<PriceType>>;
  neq?: InputMaybe<PriceType>;
  nin?: InputMaybe<Array<PriceType>>;
};

export type PricesInput = {
  basePriceBrutto?: InputMaybe<PriceRecordBaseInput>;
  workingPriceBrutto?: InputMaybe<PriceRecordInput>;
};

export type ProductFilterInput = {
  activeFrom?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  activeUntil?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  addOnOf?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProductFilterInput>>;
  category?: InputMaybe<CategoriesOperationFilterInput>;
  contractProductStatus?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  descriptionHtml?: InputMaybe<StringOperationFilterInput>;
  mandatoryAddOn?: InputMaybe<StringOperationFilterInput>;
  nextProductCodes?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  productName?: InputMaybe<StringOperationFilterInput>;
  productType?: InputMaybe<StringOperationFilterInput>;
  productVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sortRank?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  usageNtPercentage?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ProductSortInput = {
  activeFrom?: InputMaybe<SortEnumType>;
  activeUntil?: InputMaybe<SortEnumType>;
  addOnOf?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  contractProductStatus?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  descriptionHtml?: InputMaybe<SortEnumType>;
  mandatoryAddOn?: InputMaybe<SortEnumType>;
  productCode?: InputMaybe<SortEnumType>;
  productName?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<SortEnumType>;
  productVersion?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  sortRank?: InputMaybe<SortEnumType>;
  usageNtPercentage?: InputMaybe<SortEnumType>;
};

export type ProviderFilterInput = {
  and?: InputMaybe<Array<ProviderFilterInput>>;
  codeNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProviderFilterInput>>;
};

export type ProviderSortInput = {
  codeNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPrimary?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum PushNotificationErrorType {
  Failed = 'FAILED',
  None = 'NONE',
}

export type QrCodeUrlInput = {
  qrCode: Scalars['String']['input'];
};

export enum ReachabilityForContact {
  AllDay = 'ALL_DAY',
  PreferredEvening = 'PREFERRED_EVENING',
  PreferredMorning = 'PREFERRED_MORNING',
  PreferredNoon = 'PREFERRED_NOON',
}

export type ReadingFilterInput = {
  and?: InputMaybe<Array<ReadingFilterInput>>;
  /** Date reading was submitted in format yyyy-mm-dd */
  createdAt?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  implausibleReason?: InputMaybe<StringOperationFilterInput>;
  implausibleReasonExplanation?: InputMaybe<StringOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ReadingFilterInput>>;
  origin?: InputMaybe<ReadingOriginOperationFilterInput>;
  qualifier?: InputMaybe<NullableOfReadingQualifierOperationFilterInput>;
  /** Reading Date in international format yyyy-mm-dd */
  readingDate?: InputMaybe<StringOperationFilterInput>;
  readingType?: InputMaybe<ReadingTypesOperationFilterInput>;
  value?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export enum ReadingOrigin {
  Bycarrier = 'BYCARRIER',
  Bycustomer = 'BYCUSTOMER',
  Calculated = 'CALCULATED',
  Other = 'OTHER',
  Previousprovider = 'PREVIOUSPROVIDER',
  Thirdparty = 'THIRDPARTY',
}

export type ReadingOriginOperationFilterInput = {
  eq?: InputMaybe<ReadingOrigin>;
  in?: InputMaybe<Array<ReadingOrigin>>;
  neq?: InputMaybe<ReadingOrigin>;
  nin?: InputMaybe<Array<ReadingOrigin>>;
};

export enum ReadingQualifier {
  Estimated = 'ESTIMATED',
  Forecast = 'FORECAST',
  Other = 'OTHER',
  Read = 'READ',
  Suggested = 'SUGGESTED',
  Sum = 'SUM',
  Unknown = 'UNKNOWN',
}

export type ReadingSortInput = {
  /** Date reading was submitted in format yyyy-mm-dd */
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  implausibleReason?: InputMaybe<SortEnumType>;
  implausibleReasonExplanation?: InputMaybe<SortEnumType>;
  isValid?: InputMaybe<SortEnumType>;
  origin?: InputMaybe<SortEnumType>;
  qualifier?: InputMaybe<SortEnumType>;
  /** Reading Date in international format yyyy-mm-dd */
  readingDate?: InputMaybe<SortEnumType>;
  readingType?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export enum ReadingTypes {
  Counterbegin = 'COUNTERBEGIN',
  Counterend = 'COUNTEREND',
  Cycle = 'CYCLE',
  Estimation = 'ESTIMATION',
  Inbetween = 'INBETWEEN',
  Intermediateestimation = 'INTERMEDIATEESTIMATION',
  Manual = 'MANUAL',
  Meterassembly = 'METERASSEMBLY',
  Meterdisassembly = 'METERDISASSEMBLY',
  Movingin = 'MOVINGIN',
  Movingout = 'MOVINGOUT',
  Notspecified = 'NOTSPECIFIED',
  Unknown = 'UNKNOWN',
}

export type ReadingTypesOperationFilterInput = {
  eq?: InputMaybe<ReadingTypes>;
  in?: InputMaybe<Array<ReadingTypes>>;
  neq?: InputMaybe<ReadingTypes>;
  nin?: InputMaybe<Array<ReadingTypes>>;
};

export type RegisterCustomerInput = {
  /** Customer id */
  customerId: Scalars['Int']['input'];
  /** Customer email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Marketing-Text */
  marketingText?: InputMaybe<Scalars['String']['input']>;
  /** Opt-In for email */
  optIn: Scalars['Boolean']['input'];
  /** Registration code */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterCustomerInputWithMailInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  marketingText?: InputMaybe<Scalars['String']['input']>;
  optIn: Scalars['Boolean']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum RegisterCustomerStatus {
  Duplicateemail = 'DUPLICATEEMAIL',
  Duplicateemailinad = 'DUPLICATEEMAILINAD',
  Duplicateemailinpcl = 'DUPLICATEEMAILINPCL',
  Error = 'ERROR',
  Gdprlocked = 'GDPRLOCKED',
  Invalidparameters = 'INVALIDPARAMETERS',
  Invalidtoken = 'INVALIDTOKEN',
  Success = 'SUCCESS',
}

export enum RegisterCustomerWithEmailStatus {
  Duplicateemail = 'DUPLICATEEMAIL',
  Duplicateemailinad = 'DUPLICATEEMAILINAD',
  Duplicateemailinpcl = 'DUPLICATEEMAILINPCL',
  Error = 'ERROR',
  Invalidparameters = 'INVALIDPARAMETERS',
  Isb2B = 'ISB2B',
  Notfound = 'NOTFOUND',
  Success = 'SUCCESS',
}

export type RegisterFilterInput = {
  activeFrom?: InputMaybe<ComparableDateTimeOffsetOperationFilterInput>;
  activeUntil?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  and?: InputMaybe<Array<RegisterFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  digits?: InputMaybe<ComparableInt32OperationFilterInput>;
  obis?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RegisterFilterInput>>;
  precision?: InputMaybe<ComparableInt32OperationFilterInput>;
  readings?: InputMaybe<ListFilterInputTypeOfReadingFilterInput>;
  registerType?: InputMaybe<NullableOfRegisterTypeOperationFilterInput>;
};

export type RegisterReadingInput = {
  /** OBIS-Code for the register */
  obisCode?: InputMaybe<Scalars['String']['input']>;
  /** Value of the register */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RegisterType {
  Ht = 'HT',
  Nt = 'NT',
  Unknown = 'UNKNOWN',
}

export enum RelocationAddressTransfer {
  Instant = 'INSTANT',
  None = 'NONE',
  Onarrival = 'ONARRIVAL',
}

export enum RoofAge {
  DontKnow = 'DONT_KNOW',
  No = 'NO',
  Yes = 'YES',
}

export type RoofDetailsInput = {
  /** Indicates either the roof was changed in the last 5 years */
  age?: InputMaybe<Scalars['Int']['input']>;
  areaSize?: InputMaybe<Scalars['Decimal']['input']>;
  inclination?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['Int']['input']>;
};

export enum RoofIndication {
  Easy = 'EASY',
  Flat = 'FLAT',
  Moderate = 'MODERATE',
  Normal = 'NORMAL',
  Strong = 'STRONG',
  VeryStrong = 'VERY_STRONG',
}

export enum RoofMaterial {
  Asbestos = 'ASBESTOS',
  Beavertail = 'BEAVERTAIL',
  Brick = 'BRICK',
  CardboardSkein = 'CARDBOARD_SKEIN',
  CorrugatedIron = 'CORRUGATED_IRON',
  GravelRoof = 'GRAVEL_ROOF',
  GreenRoof = 'GREEN_ROOF',
  Miscellaneous = 'MISCELLANEOUS',
  Plastic = 'PLASTIC',
  RoofingMembraneBitumen = 'ROOFING_MEMBRANE_BITUMEN',
  Slate = 'SLATE',
  StandingSeamSheet = 'STANDING_SEAM_SHEET',
  TrapezoidalSheetMetal = 'TRAPEZOIDAL_SHEET_METAL',
}

export enum RoofOrientation {
  East = 'EAST',
  North = 'NORTH',
  NorthEast = 'NORTH_EAST',
  NorthWest = 'NORTH_WEST',
  South = 'SOUTH',
  SouthEast = 'SOUTH_EAST',
  SouthWest = 'SOUTH_WEST',
  West = 'WEST',
}

export enum Salutation {
  Familie = 'FAMILIE',
  Frau = 'FRAU',
  Herr = 'HERR',
  Ohne = 'OHNE',
}

export enum Salutations {
  Firma = 'FIRMA',
  Frau = 'FRAU',
  Herr = 'HERR',
  Unknown = 'UNKNOWN',
}

export enum SaveFavoriteStationsErrorType {
  None = 'NONE',
  UserNotFound = 'USER_NOT_FOUND',
}

export type SaveFavoriteStationsInput = {
  chargePointIds: Array<Scalars['String']['input']>;
};

export enum ScheduleActivationStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
}

export enum ScheduleMissingChargeLogsImportForUserErrorType {
  UserNotValid = 'USER_NOT_VALID',
}

export type SetMessageReadStatusInput = {
  hasBeenRead: Scalars['Boolean']['input'];
  /** One or more Message-Ids or Invoice-Id */
  messageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specifies the Message Type to which the given MessageIds belong */
  messageType: MessageType;
};

export type SmartChargingScheduleFilterInput = {
  and?: InputMaybe<Array<SmartChargingScheduleFilterInput>>;
  chargingScheduleStatus?: InputMaybe<ChargingScheduleStatusOperationFilterInput>;
  forecastGridSupply?: InputMaybe<ComparableInt32OperationFilterInput>;
  forecastGridSupplyPercentage?: InputMaybe<ComparableInt32OperationFilterInput>;
  forecastGridSupplyWh?: InputMaybe<ComparableInt32OperationFilterInput>;
  forecastPvSelfConsumption?: InputMaybe<ComparableInt32OperationFilterInput>;
  forecastPvSelfConsumptionPercentage?: InputMaybe<ComparableInt32OperationFilterInput>;
  forecastPvSelfConsumptionWh?: InputMaybe<ComparableInt32OperationFilterInput>;
  forecastTotalEnergy?: InputMaybe<ComparableInt32OperationFilterInput>;
  forecastTotalEnergyWh?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<SmartChargingScheduleFilterInput>>;
  scheduleActivationStatus?: InputMaybe<NullableOfScheduleActivationStatusOperationFilterInput>;
  smartChargingDurationSeconds?: InputMaybe<ComparableInt32OperationFilterInput>;
  smartChargingEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  smartChargingStart?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type SmoothedEnergyPriceCurvesInput = {
  end: Scalars['DateTime']['input'];
  powerCloudContractId: Scalars['Int']['input'];
  priceCurveAggregation: PriceCurveAggregation;
  start: Scalars['DateTime']['input'];
};

export type SolarHardwareComponentInput = {
  /** Hardware component Id */
  id: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type SolarPanelInstallationLeadInput = {
  allowedGoogleMaps?: InputMaybe<Scalars['Boolean']['input']>;
  buildingAge?: InputMaybe<Scalars['Int']['input']>;
  buildingType?: InputMaybe<BuildingType>;
  channel?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactAddress?: InputMaybe<NcsLeadAddressInput>;
  desiredTimeOfInstallation?: InputMaybe<DesiredTimeOfInstallation>;
  doiTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  electricCarExists?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  existingCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  experimentsUsed?: InputMaybe<Array<ExperimentInput>>;
  expertMode?: InputMaybe<ExpertModeInput>;
  externalLeadId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  heatEmissionType?: InputMaybe<HeatEmissionTypeInput>;
  heatedArea?: InputMaybe<Scalars['Decimal']['input']>;
  heatingConsumption?: InputMaybe<Scalars['Decimal']['input']>;
  heatingSystemAge?: InputMaybe<Scalars['Int']['input']>;
  highConsumptionTime?: InputMaybe<HighConsuptionTime>;
  houseType?: InputMaybe<HouseType>;
  houseYearOfConstruction?: InputMaybe<YearOfConstructionInput>;
  houseYearOfModernization?: InputMaybe<Scalars['Int']['input']>;
  installationAddress: NcsLeadAddressInput;
  interestInHeatPump?: InputMaybe<Scalars['Boolean']['input']>;
  interestInPv?: InputMaybe<Scalars['Boolean']['input']>;
  interestInStromWallet?: InputMaybe<Scalars['Boolean']['input']>;
  interestInWallBox?: InputMaybe<Scalars['Boolean']['input']>;
  isHouseOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isImportedLead?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  legalText?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  marketingCampaign?: InputMaybe<Scalars['String']['input']>;
  marketingLegalConsentText?: InputMaybe<Scalars['String']['input']>;
  numberOfResidents?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  powerConsumption?: InputMaybe<Scalars['Decimal']['input']>;
  powerConsumptionElectricCar?: InputMaybe<Scalars['Decimal']['input']>;
  reachabilityForContact?: InputMaybe<ReachabilityForContact>;
  referralInformation?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['UUID']['input'];
  roofAge?: InputMaybe<RoofAge>;
  roofAreaSize?: InputMaybe<Scalars['Decimal']['input']>;
  roofInclination?: InputMaybe<RoofIndication>;
  roofMaterial?: InputMaybe<RoofMaterial>;
  roofOrientation?: InputMaybe<RoofOrientation>;
  solarDefaultValues?: InputMaybe<Scalars['String']['input']>;
  webCampaignId?: InputMaybe<Scalars['String']['input']>;
};

export type SolarPotentialInput = {
  averageRadationAmount?: InputMaybe<Scalars['Decimal']['input']>;
  powerOutput?: InputMaybe<Scalars['Decimal']['input']>;
  yield?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SolarSystemCalculationInput = {
  /** Fee that customer should pay yearly for smart metering */
  annualSmartMeteringFee?: InputMaybe<Scalars['Decimal']['input']>;
  /** Average radiation on the roof */
  averageRadationOnRoof?: InputMaybe<Scalars['Decimal']['input']>;
  /** Electricity base price */
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** Battery capacity */
  batteryCapacity: Scalars['Decimal']['input'];
  /** If the offer is indicative CrmRecordId = OpportunityId else CrmRecordId = QuoteId */
  crmRecordId: Scalars['String']['input'];
  /** Indicates if customer interested in Heatpump */
  heatpump: Scalars['Boolean']['input'];
  /** Indicates if customer interested smart meter */
  imSys: Scalars['Boolean']['input'];
  /** Additional hardware like Heatpump and Wallbox */
  include?: InputMaybe<Array<SolarHardwareComponentInput>>;
  /**
   * Indicated if the customer is an existing LichtBlick customer
   * @deprecated Not used in calculations anymore
   */
  isLichtBlickCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Latitude of the building */
  latitude: Scalars['Decimal']['input'];
  /** Longitude of the building */
  longitude: Scalars['Decimal']['input'];
  /** Number of solar modules for selected module id */
  panelModule: SolarHardwareComponentInput;
  /** PostalCode of the building */
  postalCode: Scalars['String']['input'];
  /** Household power consumption */
  powerConsumption: Scalars['Int']['input'];
  /** Power consumption of the Heatpump */
  powerConsumptionHeatpump?: InputMaybe<Scalars['Int']['input']>;
  /** Power consumption of the Wallbox */
  powerConsumptionWallbox?: InputMaybe<Scalars['Int']['input']>;
  /** Amount of energy system produces in peak(one module produce * amount of modules) */
  pvPower?: InputMaybe<Scalars['Decimal']['input']>;
  /** Amount of energy system produces yearly */
  pvYield?: InputMaybe<Scalars['Decimal']['input']>;
  /** The age of the roof */
  roofAge?: InputMaybe<Scalars['Int']['input']>;
  /** Roof area size for installing solar panels */
  roofAreaSize?: InputMaybe<Scalars['Decimal']['input']>;
  /** Roof inclination */
  roofInclination?: InputMaybe<Scalars['Int']['input']>;
  /** Roof orientation */
  roofOrientation?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the sales partner */
  salesPartner?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if customer needs scaffolding */
  scaffold: Scalars['Boolean']['input'];
  /** The name of the packet in the price list */
  solarPackage: Scalars['String']['input'];
  /** Indicates if customer interested in Wallbox */
  wallbox: Scalars['Boolean']['input'];
  /** Electricity work price */
  workPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum SolarSystemOfferCalculationStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum Standard {
  Ccs = 'CCS',
  ChAdeMo = 'CH_ADE_MO',
  Domestic = 'DOMESTIC',
  Other = 'OTHER',
  Type1 = 'TYPE1',
  Type2 = 'TYPE2',
  Type3 = 'TYPE3',
}

export type StandardOperationFilterInput = {
  eq?: InputMaybe<Standard>;
  in?: InputMaybe<Array<Standard>>;
  neq?: InputMaybe<Standard>;
  nin?: InputMaybe<Array<Standard>>;
};

export enum StartChargeErrorType {
  CardInactive = 'CARD_INACTIVE',
  None = 'NONE',
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  Other = 'OTHER',
  RetryLater = 'RETRY_LATER',
  Unavailable = 'UNAVAILABLE',
}

export type StartChargingInput = {
  evseId: Scalars['String']['input'];
};

export enum StartEvseChargingErrorType {
  ConnectionError = 'CONNECTION_ERROR',
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
}

export type StartEvseChargingInput = {
  evseId: Scalars['UUID']['input'];
};

export type StartSmartChargingInput = {
  energyWh?: InputMaybe<Scalars['Int']['input']>;
  evseId: Scalars['UUID']['input'];
  repeatDaily?: InputMaybe<Scalars['Boolean']['input']>;
  smartChargingEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated This field is deprecated and will be removed in future versions. Use SmartChargingEnd instead. */
  smartChargingEndTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** @deprecated This field is deprecated and will be removed in future versions. Start is not needed because customer is not providing it at all */
  smartChargingStart?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A station is a physical apparatus one or more plugs. */
export type StationFilterInput = {
  and?: InputMaybe<Array<StationFilterInput>>;
  capabilities?: InputMaybe<ListCapabilitiesOperationFilterInput>;
  /** The plug the station provides. */
  connector?: InputMaybe<ConnectorFilterInput>;
  connectorId?: InputMaybe<StringOperationFilterInput>;
  connectors?: InputMaybe<ListFilterInputTypeOfConnectorFilterInput>;
  /** EVSE Id. */
  evseId?: InputMaybe<StringOperationFilterInput>;
  evseIdInvariant?: InputMaybe<StringOperationFilterInput>;
  isFree?: InputMaybe<BooleanOperationFilterInput>;
  /** Last Update. */
  lastUpdated?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<StationFilterInput>>;
  /** Current status at the time of the last update. May be delayed in queries. */
  status?: InputMaybe<ConnectorStatusOperationFilterInput>;
};

export enum StopChargeErrorType {
  ChargingNotFound = 'CHARGING_NOT_FOUND',
  InactiveCard = 'INACTIVE_CARD',
  None = 'NONE',
  Other = 'OTHER',
  RemoteStop = 'REMOTE_STOP',
  Unavailable = 'UNAVAILABLE',
}

export type StopChargingErrorFeedbackInput = {
  chargeDetailRecordId: Scalars['String']['input'];
  feedbackType: StopChargingErrorFeedbackType;
};

export enum StopChargingErrorFeedbackType {
  ActiveOnStation = 'ACTIVE_ON_STATION',
  StoppedOnStation = 'STOPPED_ON_STATION',
}

export type StopChargingInput = {
  chargeId: Scalars['String']['input'];
};

export enum StopEvseChargingErrorType {
  ConnectionError = 'CONNECTION_ERROR',
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
}

export type StopEvseChargingInput = {
  evseId: Scalars['UUID']['input'];
};

export type StreetFilterInput = {
  and?: InputMaybe<Array<StreetFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StreetFilterInput>>;
};

export type StreetSortInput = {
  name?: InputMaybe<SortEnumType>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum StromWalletActivationTask {
  ConfigureMeter = 'CONFIGURE_METER',
  SwitchToDynamic = 'SWITCH_TO_DYNAMIC',
  SwitchToVario = 'SWITCH_TO_VARIO',
}

export enum StromWalletTaskStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export enum StromWalletVersionInput {
  IsonStromWalletV2 = 'ISON_STROM_WALLET_V2',
  StromWalletV2 = 'STROM_WALLET_V2',
}

export enum SubmitContactFormErrorType {
  FilesRetrievalFailed = 'FILES_RETRIEVAL_FAILED',
  None = 'NONE',
  SubmissionFailed = 'SUBMISSION_FAILED',
  TooManyFiles = 'TOO_MANY_FILES',
}

export type SubmitContactFormInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['Long']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  device?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fileIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform: Platform;
  postCode?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  ticketRoutingKey: Scalars['String']['input'];
  title: Scalars['String']['input'];
  /** @deprecated The UploadedFiles field is now deprecated. Please use the FileIds field instead to reference uploaded files. */
  uploadedFiles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SubmitMeterReadingNotAllowedReason {
  Expired = 'EXPIRED',
  FinalInvoiceSubmitted = 'FINAL_INVOICE_SUBMITTED',
  HasSmartMeter = 'HAS_SMART_METER',
  MeterNotRegistered = 'METER_NOT_REGISTERED',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
}

export type SuitableForEmobilityContractInput = {
  contractProducts: Array<SuitableForEmobilityContractProductInput>;
};

export enum SuitableForEmobilityContractProductCategories {
  Article = 'ARTICLE',
  Dynamictariff = 'DYNAMICTARIFF',
  Eaas = 'EAAS',
  Fahrstrom = 'FAHRSTROM',
  Gas = 'GAS',
  Heatpump = 'HEATPUMP',
  Power = 'POWER',
  Power2Car = 'POWER2CAR',
  Service = 'SERVICE',
  Spot = 'SPOT',
  Storageheater = 'STORAGEHEATER',
  Unknown = 'UNKNOWN',
}

export enum SuitableForEmobilityContractProductContractStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Cancellationpreviousprovider = 'CANCELLATIONPREVIOUSPROVIDER',
  Cancelled = 'CANCELLED',
  Deliverynet = 'DELIVERYNET',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Revoked = 'REVOKED',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING',
}

export type SuitableForEmobilityContractProductInput = {
  contractStatus: SuitableForEmobilityContractProductContractStatus;
  productCategory: SuitableForEmobilityContractProductCategories;
  productCode: Scalars['String']['input'];
};

export type TariffFilterInput = {
  activeFrom?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  activeUntil?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TariffFilterInput>>;
  basePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  cancellationPeriod?: InputMaybe<ComparableInt32OperationFilterInput>;
  depositDivisor?: InputMaybe<ComparableInt32OperationFilterInput>;
  extensionTime?: InputMaybe<ComparableInt32OperationFilterInput>;
  fixedPriceDate?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  fixedPriceMonths?: InputMaybe<ComparableInt32OperationFilterInput>;
  fixedPriceType?: InputMaybe<FixedPriceTypeOperationFilterInput>;
  minimumRuntime?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TariffFilterInput>>;
  productName?: InputMaybe<StringOperationFilterInput>;
  terminationPeriod?: InputMaybe<PeriodFilterInput>;
  workingPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  workingPriceNt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

/** Tariff information that matches the existing stations on location level. */
export type TariffInformationFilterInput = {
  and?: InputMaybe<Array<TariffInformationFilterInput>>;
  /** Category to match station. */
  key?: InputMaybe<CategoryOperationFilterInput>;
  or?: InputMaybe<Array<TariffInformationFilterInput>>;
  /** Type of tariff to match contract / user settings. */
  type?: InputMaybe<EmobilityTariffTypeOperationFilterInput>;
  /** Value (price in €). */
  value?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export type TariffInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  cityId: Scalars['Int']['input'];
  energy: Energy;
  productCode?: InputMaybe<Scalars['String']['input']>;
  usage: Scalars['Int']['input'];
  usageNt?: InputMaybe<Scalars['Int']['input']>;
};

export type TariffOfferFilterInput = {
  agbLink?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TariffOfferFilterInput>>;
  averageSpotPricePreviousMonthCtKwh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  basePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  basePriceNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  basePriceTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bonus?: InputMaybe<BonusFilterInput>;
  bonusParagraph?: InputMaybe<ParagraphFilterInput>;
  bonuses?: InputMaybe<ListFilterInputTypeOfBonusFilterInput>;
  cityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  consumptionType?: InputMaybe<ConsumptionTypeOperationFilterInput>;
  contractPeriod?: InputMaybe<PeriodFilterInput>;
  contractRenewalPeriod?: InputMaybe<PeriodFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  descriptionHtml?: InputMaybe<StringOperationFilterInput>;
  descriptionMd?: InputMaybe<StringOperationFilterInput>;
  gridFeeReductions?: InputMaybe<GridFeeReductionsFilterInput>;
  instantBonus?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  invalidReasons?: InputMaybe<ListStringOperationFilterInput>;
  isValid?: InputMaybe<BooleanOperationFilterInput>;
  legalParagraph?: InputMaybe<ParagraphFilterInput>;
  monthlyBasePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  monthlyBasePriceNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  monthlyPriceWithBonus?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  monthlyRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  monthlyTaxRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  monthlyUsage?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  monthlyUsageHt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  monthlyUsageNt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TariffOfferFilterInput>>;
  priceCapData?: InputMaybe<PriceCapDataFilterInput>;
  priceGuarantee?: InputMaybe<PeriodFilterInput>;
  priceGuaranteeType?: InputMaybe<PriceGuaranteesOperationFilterInput>;
  priceKey?: InputMaybe<StringOperationFilterInput>;
  priceType?: InputMaybe<PriceTypeOperationFilterInput>;
  productCategory?: InputMaybe<CategoriesOperationFilterInput>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  subLine?: InputMaybe<StringOperationFilterInput>;
  tariffOfferToken?: InputMaybe<StringOperationFilterInput>;
  totalPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalPriceNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalPriceNoBonus?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalPriceTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalWorkPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalWorkPriceNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  usage?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  usageHt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  usageNt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  workPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  workPriceNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  workPriceNt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  workPriceNtNet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type TariffOfferRequestInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  cityId: Scalars['Int']['input'];
  energy: Energy;
  includeInstantBonus?: InputMaybe<Scalars['Boolean']['input']>;
  includeInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  usage: Scalars['Int']['input'];
  usageNt?: InputMaybe<Scalars['Int']['input']>;
};

export type TariffOfferSortInput = {
  agbLink?: InputMaybe<SortEnumType>;
  averageSpotPricePreviousMonthCtKwh?: InputMaybe<SortEnumType>;
  basePrice?: InputMaybe<SortEnumType>;
  basePriceNet?: InputMaybe<SortEnumType>;
  basePriceTax?: InputMaybe<SortEnumType>;
  bonus?: InputMaybe<BonusSortInput>;
  bonusParagraph?: InputMaybe<ParagraphSortInput>;
  cityId?: InputMaybe<SortEnumType>;
  consumptionType?: InputMaybe<SortEnumType>;
  contractPeriod?: InputMaybe<PeriodSortInput>;
  contractRenewalPeriod?: InputMaybe<PeriodSortInput>;
  description?: InputMaybe<SortEnumType>;
  descriptionHtml?: InputMaybe<SortEnumType>;
  descriptionMd?: InputMaybe<SortEnumType>;
  gridFeeReductions?: InputMaybe<GridFeeReductionsSortInput>;
  instantBonus?: InputMaybe<SortEnumType>;
  isValid?: InputMaybe<SortEnumType>;
  legalParagraph?: InputMaybe<ParagraphSortInput>;
  monthlyBasePrice?: InputMaybe<SortEnumType>;
  monthlyBasePriceNet?: InputMaybe<SortEnumType>;
  monthlyPriceWithBonus?: InputMaybe<SortEnumType>;
  monthlyRate?: InputMaybe<SortEnumType>;
  monthlyTaxRate?: InputMaybe<SortEnumType>;
  monthlyUsage?: InputMaybe<SortEnumType>;
  monthlyUsageHt?: InputMaybe<SortEnumType>;
  monthlyUsageNt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  priceCapData?: InputMaybe<PriceCapDataSortInput>;
  priceGuarantee?: InputMaybe<PeriodSortInput>;
  priceGuaranteeType?: InputMaybe<SortEnumType>;
  priceKey?: InputMaybe<SortEnumType>;
  priceType?: InputMaybe<SortEnumType>;
  productCategory?: InputMaybe<SortEnumType>;
  productCode?: InputMaybe<SortEnumType>;
  subLine?: InputMaybe<SortEnumType>;
  tariffOfferToken?: InputMaybe<SortEnumType>;
  totalPrice?: InputMaybe<SortEnumType>;
  totalPriceNet?: InputMaybe<SortEnumType>;
  totalPriceNoBonus?: InputMaybe<SortEnumType>;
  totalPriceTax?: InputMaybe<SortEnumType>;
  totalWorkPrice?: InputMaybe<SortEnumType>;
  totalWorkPriceNet?: InputMaybe<SortEnumType>;
  usage?: InputMaybe<SortEnumType>;
  usageHt?: InputMaybe<SortEnumType>;
  usageNt?: InputMaybe<SortEnumType>;
  workPrice?: InputMaybe<SortEnumType>;
  workPriceNet?: InputMaybe<SortEnumType>;
  workPriceNt?: InputMaybe<SortEnumType>;
  workPriceNtNet?: InputMaybe<SortEnumType>;
};

export enum TriggerChangePasswordStatus {
  Ok = 'OK',
}

export type TriggerForgotPasswordInput = {
  email: Scalars['EmailAddress']['input'];
};

export enum TriggerForgotPasswordStatus {
  Ok = 'OK',
}

export enum UpdateCustomerPayloadError {
  /** Unbekannter Fehler */
  Undefined = 'UNDEFINED',
}

export enum UpdateEvseErrorType {
  ConnectionError = 'CONNECTION_ERROR',
  Failed = 'FAILED',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  NotSupported = 'NOT_SUPPORTED',
}

export enum UpdateEvseModeErrorType {
  EvseNotFound = 'EVSE_NOT_FOUND',
  Failed = 'FAILED',
  InvalidMode = 'INVALID_MODE',
  None = 'NONE',
  Unknown = 'UNKNOWN',
}

export type UpdateEvseModeInput = {
  evseId: Scalars['UUID']['input'];
  mode: EvseChargingMode;
};

export type UpdatePushNotificationRegistrationInput = {
  deviceId: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  isNotificationEnabled: Scalars['Boolean']['input'];
  platform: Platform;
};

export type UsageInput = {
  ht: Scalars['Int']['input'];
  nt?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAccountExistsInput = {
  email: Scalars['EmailAddress']['input'];
};

export type ValidateRegisterCustomerInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum ValidateRegisterCustomerStatus {
  Invalidparameters = 'INVALIDPARAMETERS',
  Isb2B = 'ISB2B',
  Notfound = 'NOTFOUND',
  Success = 'SUCCESS',
  Unexpected = 'UNEXPECTED',
}

export enum ValidateTariffChangeCodeError {
  /** Angebot wurde bereits angenommen */
  Alreadyaccepted = 'ALREADYACCEPTED',
  /** Es wurden mehrere Angebote zum selben AngebotsCode gefunden */
  Ambiguousoffercode = 'AMBIGUOUSOFFERCODE',
  /** Eine Kündigung wurde ausgesprochen aber noch nicht durchgeführt */
  Contractcancellationrequested = 'CONTRACTCANCELLATIONREQUESTED',
  /** Vertrag wurde gekündigt */
  Contractcancelled = 'CONTRACTCANCELLED',
  /** Vertrag zum Kunden nicht vorhanden */
  Contractmissing = 'CONTRACTMISSING',
  /** Parameter hat ungültigen Wert */
  Invalidvalue = 'INVALIDVALUE',
  /** Angebot ist Mehrtarif */
  Multipletariffs = 'MULTIPLETARIFFS',
  /** Kunde nicht vorhanden */
  Notmigrated = 'NOTMIGRATED',
  /** Angebot ist nicht mehr gültig */
  Offerexpired = 'OFFEREXPIRED',
  /** Anderes Angebot wurde bereits angenommen */
  Otherofferaccepted = 'OTHEROFFERACCEPTED',
  /** Unbekannter Fehler */
  Undefined = 'UNDEFINED',
  /** Speichern fehlgeschlagen */
  Updatefailed = 'UPDATEFAILED',
  /** Wert fehlt */
  Valuenotset = 'VALUENOTSET',
}

export type ValidateZipCodeForSystemInstallationInput = {
  zipCode: Scalars['String']['input'];
};

export enum YearOfConstructionInput {
  After_1994 = 'AFTER_1994',
  Before_1969 = 'BEFORE_1969',
  NewBuilding = 'NEW_BUILDING',
  '1969To_1976' = '_1969_TO_1976',
  '1977To_1994' = '_1977_TO_1994',
}

export type B2bcsCreateLeadFormMutationVariables = Exact<{
  input: B2bcsCreateLeadFormInput;
}>;

export type B2bcsCreateLeadFormMutation = {
  __typename?: 'Mutation';
  b2bcsCreateLeadForm: {
    __typename?: 'B2bcsCreateLeadFormPayload';
    errorType?: B2bcsCreateLeadFormErrorType | null;
    data?: { __typename?: 'B2bcsCreateLeadFormResponse'; trackingId?: string | null } | null;
  };
};

export type B2bcsSubmitLeadFormMutationVariables = Exact<{
  input: B2bcsSubmitLeadFormInput;
}>;

export type B2bcsSubmitLeadFormMutation = {
  __typename?: 'Mutation';
  b2bcsSubmitLeadForm: {
    __typename?: 'B2bcsSubmitLeadFormPayload';
    errorType?: B2bcsSubmitLeadFormErrorType | null;
    data?: { __typename?: 'B2bcsSubmitLeadFormResponse'; trackingId?: string | null } | null;
  };
};

export type B2cAddLevyPrivilegeApplicationMutationVariables = Exact<{
  input: B2cAddLevyPrivilegeApplicationInput;
}>;

export type B2cAddLevyPrivilegeApplicationMutation = {
  __typename?: 'Mutation';
  b2cAddLevyPrivilegeApplication: {
    __typename?: 'B2cAddLevyPrivilegeApplicationPayload';
    b2cLevyPrivilegeApplicationPayload?: {
      __typename?: 'B2cLevyPrivilegeApplicationPayload';
      contractId: number;
      counterNumber?: string | null;
      emailAddress?: string | null;
      optIn: boolean;
      optInText: string;
    } | null;
    errors?: Array<
      | { __typename: 'CounterNumberNotFoundError' }
      | { __typename: 'CustomerContractNotFoundError' }
      | { __typename: 'LevyApplicationOptInNotValidError' }
    > | null;
  };
};

export type B2CAddCommodityLeadMutationVariables = Exact<{
  lead: B2CCommodityLeadInput;
}>;

export type B2CAddCommodityLeadMutation = {
  __typename?: 'Mutation';
  B2CAddCommodityLead: { __typename?: 'MutationResponseOfB2CCommodityLead'; success: boolean };
};

export type SubmitCategorizedContactFormMutationVariables = Exact<{
  contactFormInput: CategorizedContactFormInput;
}>;

export type SubmitCategorizedContactFormMutation = {
  __typename?: 'Mutation';
  categorizedContactForm: { __typename?: 'CustomerContactFormResult'; status: CustomerContactFormStatus };
};

export type CreateSolarPanelInstallationLeadCompactMutationVariables = Exact<{
  createSolarPanelInstallationLeadInput: CreateSolarPanelInstallationLeadInput;
}>;

export type CreateSolarPanelInstallationLeadCompactMutation = {
  __typename?: 'Mutation';
  createSolarPanelInstallationLeadCompact: { __typename?: 'SolarPanelInstallationLeadPayload'; isSend: boolean };
};

export type EaasCreateMarketingLeadMutationVariables = Exact<{
  input: CreateMarketingLeadInput;
}>;

export type EaasCreateMarketingLeadMutation = {
  __typename?: 'Mutation';
  eaasCreateMarketingLead: { __typename?: 'MarketingLeadPayload'; isSent: boolean };
};

export type NcsParkLeadMutationVariables = Exact<{
  ncsParkLeadInput: NcsParkLeadInput;
}>;

export type NcsParkLeadMutation = {
  __typename?: 'Mutation';
  ncsParkLead: { __typename?: 'NcsParkLeadPayload'; isSent: boolean };
};

export type GetCitiesQueryVariables = Exact<{
  postcode?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCitiesQuery = {
  __typename?: 'Query';
  citiesByPostcode: Array<{ __typename?: 'City'; name?: string | null; cityId: any }>;
};

export type GetCitiesAndStreetsQueryVariables = Exact<{
  postcode?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCitiesAndStreetsQuery = {
  __typename?: 'Query';
  citiesByPostcode: Array<{
    __typename?: 'City';
    name?: string | null;
    cityId: any;
    streets?: Array<{ __typename?: 'Street'; name?: string | null }> | null;
  }>;
};

export type GetContactFormReasonsQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetContactFormReasonsQuery = {
  __typename?: 'Query';
  contactFormReasons: {
    __typename?: 'ContactFormReasonsResult';
    majaId: any;
    williId?: string | null;
    status: ContactFormReasonsStatus;
    contactFormReasons?: Array<{
      __typename?: 'ContactFormReason';
      id: string;
      key?: string | null;
      label?: string | null;
      applicableB2B: boolean;
      applicableB2C: boolean;
      applicableServiceView: boolean;
      applicableWebsite: boolean;
      applicableToWebsiteForLead: boolean;
    }> | null;
  };
};

export type EnergyPriceCurveQueryVariables = Exact<{
  input: LocationSpecificEnergyPriceCurveInput;
}>;

export type EnergyPriceCurveQuery = {
  __typename?: 'Query';
  locationSpecificEnergyPriceCurve: {
    __typename?: 'EnergyPriceCurvesPayload';
    energyPriceCurvesResponse: {
      __typename?: 'EnergyPriceCurves';
      averagePriceInCents: number;
      maxPrice: { __typename?: 'EnergyPriceInCents'; time: Date; valueInCents: number };
      minPrice: { __typename?: 'EnergyPriceInCents'; time: Date; valueInCents: number };
      energyPricesInCents: Array<{ __typename?: 'EnergyPriceInCents'; time: Date; valueInCents: number }>;
      maxAvgPriceRange: { __typename?: 'TimeRangeAveragePrice'; startTime: Date; endTime: Date; averagePrice: number };
      minAvgPriceRange: { __typename?: 'TimeRangeAveragePrice'; startTime: Date; endTime: Date; averagePrice: number };
    };
  };
};

export type NonCommodityProductPartFragment = {
  __typename?: 'NonCommodityProduct';
  productCode: string;
  prices: Array<{ __typename?: 'NonCommodityPrice'; minimalAmount: number; salesPriceGross: number; validFrom: Date }>;
  extendedDataGroups: Array<{
    __typename?: 'ExtendedDataGroup';
    name: string;
    technicalKey: string;
    values: Array<{ __typename?: 'ExtendedDataValue'; name: string; technicalKey: string; value: string }>;
  }>;
  addOns: Array<{
    __typename?: 'AddOn';
    productType: string;
    productCode: string;
    prices: Array<{
      __typename?: 'NonCommodityPrice';
      minimalAmount: number;
      salesPriceGross: number;
      validFrom: Date;
    }>;
  }>;
};

export type NonCommodityAddOnPartFragment = {
  __typename?: 'AddOn';
  productType: string;
  productCode: string;
  prices: Array<{ __typename?: 'NonCommodityPrice'; minimalAmount: number; salesPriceGross: number; validFrom: Date }>;
};

export type NonCommodityPricePartFragment = {
  __typename?: 'NonCommodityPrice';
  minimalAmount: number;
  salesPriceGross: number;
  validFrom: Date;
};

export type NonCommodityExtendedDataGroupPartFragment = {
  __typename?: 'ExtendedDataGroup';
  name: string;
  technicalKey: string;
  values: Array<{ __typename?: 'ExtendedDataValue'; name: string; technicalKey: string; value: string }>;
};

export type GetNonCommodityProductsQueryVariables = Exact<{
  campaign: Scalars['String']['input'];
  productCodes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;

export type GetNonCommodityProductsQuery = {
  __typename?: 'Query';
  nonCommodityProductsByCampaign: Array<{
    __typename?: 'NonCommodityProduct';
    productCode: string;
    prices: Array<{
      __typename?: 'NonCommodityPrice';
      minimalAmount: number;
      salesPriceGross: number;
      validFrom: Date;
    }>;
    extendedDataGroups: Array<{
      __typename?: 'ExtendedDataGroup';
      name: string;
      technicalKey: string;
      values: Array<{ __typename?: 'ExtendedDataValue'; name: string; technicalKey: string; value: string }>;
    }>;
    addOns: Array<{
      __typename?: 'AddOn';
      productType: string;
      productCode: string;
      prices: Array<{
        __typename?: 'NonCommodityPrice';
        minimalAmount: number;
        salesPriceGross: number;
        validFrom: Date;
      }>;
    }>;
  }>;
};

export const NonCommodityPricePartFragmentDoc = gql`
  fragment NonCommodityPricePart on NonCommodityPrice {
    minimalAmount
    salesPriceGross
    validFrom
  }
`;
export const NonCommodityExtendedDataGroupPartFragmentDoc = gql`
  fragment NonCommodityExtendedDataGroupPart on ExtendedDataGroup {
    name
    technicalKey
    values {
      name
      technicalKey
      value
    }
  }
`;
export const NonCommodityAddOnPartFragmentDoc = gql`
  fragment NonCommodityAddOnPart on AddOn {
    productType
    productCode
    prices {
      ...NonCommodityPricePart
    }
  }
  ${NonCommodityPricePartFragmentDoc}
`;
export const NonCommodityProductPartFragmentDoc = gql`
  fragment NonCommodityProductPart on NonCommodityProduct {
    productCode
    prices {
      ...NonCommodityPricePart
    }
    extendedDataGroups {
      ...NonCommodityExtendedDataGroupPart
    }
    addOns {
      ...NonCommodityAddOnPart
    }
  }
  ${NonCommodityPricePartFragmentDoc}
  ${NonCommodityExtendedDataGroupPartFragmentDoc}
  ${NonCommodityAddOnPartFragmentDoc}
`;
export const B2bcsCreateLeadFormDocument = gql`
  mutation B2bcsCreateLeadForm($input: B2bcsCreateLeadFormInput!) {
    b2bcsCreateLeadForm(input: $input) {
      errorType
      data {
        trackingId
      }
    }
  }
`;
export const B2bcsSubmitLeadFormDocument = gql`
  mutation B2bcsSubmitLeadForm($input: B2bcsSubmitLeadFormInput!) {
    b2bcsSubmitLeadForm(input: $input) {
      errorType
      data {
        trackingId
      }
    }
  }
`;
export const B2cAddLevyPrivilegeApplicationDocument = gql`
  mutation B2cAddLevyPrivilegeApplication($input: B2cAddLevyPrivilegeApplicationInput!) {
    b2cAddLevyPrivilegeApplication(input: $input) {
      b2cLevyPrivilegeApplicationPayload {
        contractId
        counterNumber
        emailAddress
        optIn
        optInText
      }
      errors {
        __typename
      }
    }
  }
`;
export const B2CAddCommodityLeadDocument = gql`
  mutation B2CAddCommodityLead($lead: B2CCommodityLeadInput!) {
    B2CAddCommodityLead(lead: $lead) {
      success
    }
  }
`;
export const SubmitCategorizedContactFormDocument = gql`
  mutation submitCategorizedContactForm($contactFormInput: CategorizedContactFormInput!) {
    categorizedContactForm(contactFormInput: $contactFormInput) {
      status
    }
  }
`;
export const CreateSolarPanelInstallationLeadCompactDocument = gql`
  mutation createSolarPanelInstallationLeadCompact(
    $createSolarPanelInstallationLeadInput: CreateSolarPanelInstallationLeadInput!
  ) {
    createSolarPanelInstallationLeadCompact(input: $createSolarPanelInstallationLeadInput) {
      isSend
    }
  }
`;
export const EaasCreateMarketingLeadDocument = gql`
  mutation eaasCreateMarketingLead($input: CreateMarketingLeadInput!) {
    eaasCreateMarketingLead(input: $input) {
      isSent
    }
  }
`;
export const NcsParkLeadDocument = gql`
  mutation ncsParkLead($ncsParkLeadInput: NcsParkLeadInput!) {
    ncsParkLead(input: $ncsParkLeadInput) {
      isSent
    }
  }
`;
export const GetCitiesDocument = gql`
  query getCities($postcode: String) {
    citiesByPostcode(postcode: $postcode) {
      name
      cityId
    }
  }
`;
export const GetCitiesAndStreetsDocument = gql`
  query getCitiesAndStreets($postcode: String) {
    citiesByPostcode(postcode: $postcode) {
      name
      cityId
      streets {
        name
      }
    }
  }
`;
export const GetContactFormReasonsDocument = gql`
  query getContactFormReasons($token: String) {
    contactFormReasons(token: $token) {
      contactFormReasons {
        id
        key
        label
        applicableB2B
        applicableB2C
        applicableServiceView
        applicableWebsite
        applicableToWebsiteForLead
      }
      majaId
      williId
      status
    }
  }
`;
export const EnergyPriceCurveDocument = gql`
  query EnergyPriceCurve($input: LocationSpecificEnergyPriceCurveInput!) {
    locationSpecificEnergyPriceCurve(input: $input) {
      energyPriceCurvesResponse {
        averagePriceInCents
        maxPrice {
          time
          valueInCents
        }
        minPrice {
          time
          valueInCents
        }
        energyPricesInCents {
          time
          valueInCents
        }
        maxAvgPriceRange {
          startTime
          endTime
          averagePrice
        }
        minAvgPriceRange {
          startTime
          endTime
          averagePrice
        }
      }
    }
  }
`;
export const GetNonCommodityProductsDocument = gql`
  query getNonCommodityProducts($campaign: String!, $productCodes: [String]!) {
    nonCommodityProductsByCampaign(campaignIdentifier: $campaign, where: { productCode: { in: $productCodes } }) {
      ...NonCommodityProductPart
    }
  }
  ${NonCommodityProductPartFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    B2bcsCreateLeadForm(
      variables: B2bcsCreateLeadFormMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<B2bcsCreateLeadFormMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<B2bcsCreateLeadFormMutation>(B2bcsCreateLeadFormDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'B2bcsCreateLeadForm',
        'mutation',
        variables,
      );
    },
    B2bcsSubmitLeadForm(
      variables: B2bcsSubmitLeadFormMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<B2bcsSubmitLeadFormMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<B2bcsSubmitLeadFormMutation>(B2bcsSubmitLeadFormDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'B2bcsSubmitLeadForm',
        'mutation',
        variables,
      );
    },
    B2cAddLevyPrivilegeApplication(
      variables: B2cAddLevyPrivilegeApplicationMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<B2cAddLevyPrivilegeApplicationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<B2cAddLevyPrivilegeApplicationMutation>(B2cAddLevyPrivilegeApplicationDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'B2cAddLevyPrivilegeApplication',
        'mutation',
        variables,
      );
    },
    B2CAddCommodityLead(
      variables: B2CAddCommodityLeadMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<B2CAddCommodityLeadMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<B2CAddCommodityLeadMutation>(B2CAddCommodityLeadDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'B2CAddCommodityLead',
        'mutation',
        variables,
      );
    },
    submitCategorizedContactForm(
      variables: SubmitCategorizedContactFormMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<SubmitCategorizedContactFormMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubmitCategorizedContactFormMutation>(SubmitCategorizedContactFormDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'submitCategorizedContactForm',
        'mutation',
        variables,
      );
    },
    createSolarPanelInstallationLeadCompact(
      variables: CreateSolarPanelInstallationLeadCompactMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CreateSolarPanelInstallationLeadCompactMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateSolarPanelInstallationLeadCompactMutation>(
            CreateSolarPanelInstallationLeadCompactDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'createSolarPanelInstallationLeadCompact',
        'mutation',
        variables,
      );
    },
    eaasCreateMarketingLead(
      variables: EaasCreateMarketingLeadMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<EaasCreateMarketingLeadMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<EaasCreateMarketingLeadMutation>(EaasCreateMarketingLeadDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'eaasCreateMarketingLead',
        'mutation',
        variables,
      );
    },
    ncsParkLead(
      variables: NcsParkLeadMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<NcsParkLeadMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<NcsParkLeadMutation>(NcsParkLeadDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'ncsParkLead',
        'mutation',
        variables,
      );
    },
    getCities(
      variables?: GetCitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetCitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCitiesQuery>(GetCitiesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }),
        'getCities',
        'query',
        variables,
      );
    },
    getCitiesAndStreets(
      variables?: GetCitiesAndStreetsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetCitiesAndStreetsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCitiesAndStreetsQuery>(GetCitiesAndStreetsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getCitiesAndStreets',
        'query',
        variables,
      );
    },
    getContactFormReasons(
      variables?: GetContactFormReasonsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetContactFormReasonsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetContactFormReasonsQuery>(GetContactFormReasonsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getContactFormReasons',
        'query',
        variables,
      );
    },
    EnergyPriceCurve(
      variables: EnergyPriceCurveQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<EnergyPriceCurveQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<EnergyPriceCurveQuery>(EnergyPriceCurveDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'EnergyPriceCurve',
        'query',
        variables,
      );
    },
    getNonCommodityProducts(
      variables: GetNonCommodityProductsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetNonCommodityProductsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetNonCommodityProductsQuery>(GetNonCommodityProductsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getNonCommodityProducts',
        'query',
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
